import { defineComponent, pushScopeId, popScopeId, openBlock, createBlock, resolveComponent, createVNode, withCtx, renderSlot, toDisplayString, TransitionGroup, Fragment, createCommentVNode, withScopeId, withDirectives, vModelText, vShow, renderList, createTextVNode, mergeProps, vModelDynamic, vModelSelect, resolveDirective, Transition, ref, computed, watch, watchEffect, onMounted, onUnmounted, nextTick, withKeys } from 'vue';
import _, { debounce, delay } from 'lodash';
import { mapState, mapGetters } from 'vuex';
import { Upload, UploadListSingleItemVue3 } from '@progress/kendo-vue-upload';
import { DateTime } from 'luxon';
import isEqual from 'lodash/isEqual';
import * as okta from '@okta/okta-auth-js';
import { Grid, GridNoRecords } from '@progress/kendo-vue-grid';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { AutoComplete } from '@progress/kendo-vue-dropdowns';
import { Tooltip } from '@progress/kendo-popups-vue-wrapper';
import { setDefaults, toast as toast$2 } from 'bulma-toast';
import { RouterLink } from 'vue-router';

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var script$s = defineComponent({
  name: 'brace'
});

var _hoisted_1$l = {
  class: "brace"
};

var _hoisted_2$j = /*#__PURE__*/createVNode("span", {
  class: "brace-tr"
}, " ", -1);

var _hoisted_3$e = /*#__PURE__*/createVNode("span", {
  class: "brace-tl"
}, " ", -1);

var _hoisted_4$a = /*#__PURE__*/createVNode("span", {
  class: "brace-bl"
}, " ", -1);

var _hoisted_5$8 = /*#__PURE__*/createVNode("span", {
  class: "brace-br"
}, " ", -1);

function render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$l, [_hoisted_2$j, _hoisted_3$e, _hoisted_4$a, _hoisted_5$8]);
}

script$s.render = render$s;

var script$1$1 = defineComponent({
  name: 'loadingSpinner'
});

var _hoisted_1$1$1 = {
  class: "loading-spinner"
};

var _hoisted_2$1$1 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_3$1$1 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_4$1$1 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_5$1$1 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_6$5 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_7$5 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_8$5 = /*#__PURE__*/createVNode("span", null, null, -1);

function render$1$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$1$1, [_hoisted_2$1$1, _hoisted_3$1$1, _hoisted_4$1$1, _hoisted_5$1$1, _hoisted_6$5, _hoisted_7$5, _hoisted_8$5]);
}

script$1$1.render = render$1$1;

var script$2$1 = defineComponent({
  name: "loadingModal",
  components: {
    loadingSpinner: script$1$1
  }
});

var _withId$9 = /*#__PURE__*/withScopeId("data-v-5ef2bfb9");

pushScopeId("data-v-5ef2bfb9");

var _hoisted_1$2$1 = {
  class: "box"
};
var _hoisted_2$2$1 = {
  class: "media is-vcentered"
};
var _hoisted_3$2$1 = {
  class: "media-left"
};

var _hoisted_4$2$1 = /*#__PURE__*/createVNode("div", {
  class: "media-content has-text-centered"
}, [/*#__PURE__*/createVNode("h3", null, "Loading, please wait...")], -1);

popScopeId();

var render$2$1 = /*#__PURE__*/_withId$9(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_loading_spinner = resolveComponent("loading-spinner");

  var _component_modal = resolveComponent("modal");

  return openBlock(), createBlock(_component_modal, {
    "hide-close": ""
  }, {
    default: _withId$9(function () {
      return [createVNode("div", _hoisted_1$2$1, [createVNode("div", _hoisted_2$2$1, [createVNode("figure", _hoisted_3$2$1, [createVNode(_component_loading_spinner)]), _hoisted_4$2$1])])];
    }),
    _: 1
  });
});

function styleInject$1(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$i = "\n.media-left[data-v-5ef2bfb9] {\r\n    margin-bottom: 0 !important;\n}\n.media-content[data-v-5ef2bfb9] {\r\n    overflow: visible;\n}\r\n";
styleInject$1(css_248z$i);

script$2$1.render = render$2$1;
script$2$1.__scopeId = "data-v-5ef2bfb9";

var script$3$1 = defineComponent({
  name: 'loading'
});

var _hoisted_1$3$1 = {
  class: "loading"
};

var _hoisted_2$3$1 = /*#__PURE__*/createVNode("div", null, [/*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span"), /*#__PURE__*/createVNode("span")], -1);

function render$3$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$3$1, [_hoisted_2$3$1]);
}

script$3$1.render = render$3$1;

var script$4$1 = defineComponent({
  name: 'modal-card',
  props: {
    active: {
      type: Boolean,
      required: true
    }
  }
});

var _hoisted_1$4$1 = {
  class: "modal-card-head"
};
var _hoisted_2$4$1 = {
  class: "modal-card-title"
};
var _hoisted_3$3$1 = {
  class: "modal-card-body"
};
var _hoisted_4$3$1 = {
  class: "modal-card-foot"
};
function render$4$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_modal = resolveComponent("modal");

  return openBlock(), createBlock(_component_modal, {
    class: "is-card",
    active: _ctx.active
  }, {
    default: withCtx(function () {
      return [createVNode("header", _hoisted_1$4$1, [createVNode("p", _hoisted_2$4$1, [renderSlot(_ctx.$slots, "title")])]), createVNode("section", _hoisted_3$3$1, [renderSlot(_ctx.$slots, "body")]), createVNode("footer", _hoisted_4$3$1, [renderSlot(_ctx.$slots, "foot")])];
    }),
    _: 3
  }, 8, ["active"]);
}

script$4$1.render = render$4$1;

var script$5$1 = defineComponent({
  name: "modal-dialog",
  components: {
    modalCard: script$4$1
  },
  props: {
    isSave: Boolean,
    active: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    buttonLabel: function buttonLabel() {
      return this.isSave ? "Save" : "Proceed";
    }
  },
  methods: {
    proceed: function proceed() {
      this.$emit("done", true);
    },
    cancel: function cancel() {
      this.$emit("done", false);
    }
  }
});

var _hoisted_1$5$1 = {
  class: "buttons"
};
function render$5$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_modal_card = resolveComponent("modal-card");

  return openBlock(), createBlock(_component_modal_card, {
    active: _ctx.active
  }, {
    title: withCtx(function () {
      return [renderSlot(_ctx.$slots, "title")];
    }),
    body: withCtx(function () {
      return [renderSlot(_ctx.$slots, "body")];
    }),
    foot: withCtx(function () {
      return [createVNode("div", _hoisted_1$5$1, [createVNode("button", {
        type: "button",
        class: "is-success",
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.proceed && _ctx.proceed.apply(_ctx, arguments);
        })
      }, toDisplayString(_ctx.buttonLabel), 1), createVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = function () {
          return _ctx.cancel && _ctx.cancel.apply(_ctx, arguments);
        })
      }, "Cancel")])];
    }),
    _: 1
  }, 8, ["active"]);
}

script$5$1.render = render$5$1;

var script$6$1 = defineComponent({
  name: "homeMenuItem",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
});

var _withId$1$1 = /*#__PURE__*/withScopeId("data-v-46a74a5b");

pushScopeId("data-v-46a74a5b");

var _hoisted_1$6$1 = {
  class: "media"
};
var _hoisted_2$5$1 = {
  class: "media-left"
};
var _hoisted_3$4$1 = {
  class: "icon is-large has-text-info"
};
var _hoisted_4$4$1 = {
  class: "media-content"
};
var _hoisted_5$2$1 = {
  class: "content"
};
var _hoisted_6$1$1 = {
  class: "title is-4"
};
var _hoisted_7$1$1 = {
  class: "subtitle"
};

popScopeId();

var render$6$1 = /*#__PURE__*/_withId$1$1(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = resolveComponent("router-link");

  return openBlock(), createBlock(_component_router_link, {
    class: "box",
    to: _ctx.url
  }, {
    default: _withId$1$1(function () {
      return [createVNode("article", _hoisted_1$6$1, [createVNode("div", _hoisted_2$5$1, [createVNode("span", _hoisted_3$4$1, [createVNode("i", {
        class: ["fa-2x", _ctx.icon]
      }, null, 2)])]), createVNode("div", _hoisted_4$4$1, [createVNode("div", _hoisted_5$2$1, [createVNode("h4", _hoisted_6$1$1, toDisplayString(_ctx.title), 1), createVNode("p", _hoisted_7$1$1, toDisplayString(_ctx.subtitle), 1)])])])];
    }),
    _: 1
  }, 8, ["to"]);
});

var css_248z$1$1 = "\r\n/* bulma media-content with child tags results in vertical overflow \r\n  Bulma github issue: https://github.com/jgthms/bulma/issues/1428\r\n*/\n@media screen and (max-width: 768px) {\n.media-content[data-v-46a74a5b] {\r\n    overflow-x: unset;\n}\n}\r\n";
styleInject$1(css_248z$1$1);

script$6$1.render = render$6$1;
script$6$1.__scopeId = "data-v-46a74a5b";

var script$7$1 = defineComponent({
  name: 'modal',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      docHtml: document.querySelector('html').classList,
      bodyActive: false,
      _active: this.active
    };
  },
  computed: {},
  watch: {
    active: function active(newVal) {
      this.set_active(newVal);
    }
  },
  methods: {
    set_active: function set_active(val) {
      var that = this;

      if (val) {
        this._active = true;
        this.docHtml.add('is-clipped');
        this.$nextTick(function () {
          return that.bodyActive = true;
        });
      } else {
        this.bodyActive = false;
        setTimeout(function () {
          that._active = false;
          that.docHtml.remove('is-clipped');
        }, 500);
      }
    }
  },
  mounted: function mounted() {
    this.set_active(this.active);
  }
});

var _hoisted_1$7$1 = {
  key: 0,
  class: "modal is-active"
};

var _hoisted_2$6$1 = /*#__PURE__*/createVNode("div", {
  class: "modal-background",
  key: "modal-background"
}, null, -1);

var _hoisted_3$5$1 = {
  class: "modal-body",
  key: "modal-body"
};
function render$7$1(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx._active ? (openBlock(), createBlock("div", _hoisted_1$7$1, [createVNode(TransitionGroup, {
    name: "modal"
  }, {
    default: withCtx(function () {
      return [_ctx.bodyActive ? (openBlock(), createBlock(Fragment, {
        key: 0
      }, [_hoisted_2$6$1, createVNode("div", _hoisted_3$5$1, [renderSlot(_ctx.$slots, "default")])], 64)) : createCommentVNode("", true)];
    }),
    _: 1
  })])) : createCommentVNode("", true);
}

script$7$1.render = render$7$1;

var states = {
  hard: 'hard',
  soft: 'soft',
  done: null
};
states.default = states.done;

var script$8$1 = defineComponent({
  name: "loadingManager",
  components: {
    loading: script$3$1,
    loadingModal: script$2$1
  },
  data: function data() {
    return {
      soft: states.soft,
      hard: states.hard,
      loadingState: states.default,
      modalActive: false
    };
  },
  computed: _objectSpread2({}, mapState("loadingManager", ["loading"])),
  watch: {
    loading: function loading(newVal) {
      if (!newVal || newVal === states.done) {
        this.modalActive = false;
        return;
      }

      if (newVal === states.hard) this.modalActive = true;
      this.updateLoadingState();
    }
  },
  methods: {
    updateLoadingState: function updateLoadingState() {
      this.loadingState = this.loading;
    }
  }
});

function render$8$1(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_loading = resolveComponent("loading");

  var _component_loading_modal = resolveComponent("loading-modal");

  return openBlock(), createBlock(Fragment, null, [_ctx.loadingState === _ctx.soft ? (openBlock(), createBlock(_component_loading, {
    key: 0
  })) : createCommentVNode("", true), createVNode(_component_loading_modal, {
    active: _ctx.modalActive
  }, null, 8, ["active"])], 64);
}

script$8$1.render = render$8$1;

var script$r = defineComponent({
  name: "autoComplete",
  props: {
    placeholder: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    textField: {
      type: String,
      required: false,
      default: "name"
    },
    valueField: {
      type: String,
      required: false
    },
    codeAsValue: {
      type: Boolean,
      required: false
    },
    nameAsValue: {
      type: Boolean,
      required: false
    },
    queryFn: {
      type: Function,
      required: true
    },
    getFn: {
      type: Function,
      required: false
    },
    modelValue: {
      required: false,
      default: null
    },
    id: String
  },
  components: {
    loading: script$3$1
  },
  emits: ["update:modelValue", "selected"],
  data: function data() {
    return {
      queryString: null,
      queryResults: [],
      hasFocus: false,
      isLoading: false
    };
  },
  inject: ["api"],
  mounted: function mounted() {
    if (this.selected) this.setQueryStringFromModelValue();
  },
  computed: {
    showResults: function showResults() {
      return this.queryResults.length > 0 && this.hasFocus;
    },
    _id: function _id() {
      return this.id || "".concat(this.name, "Display");
    },
    _valueField: function _valueField() {
      if (this.valueField) return this.valueField;
      if (this.codeAsValue) return "code";
      if (this.nameAsValue) return "name";
      return "id";
    },
    selected: {
      get: function get() {
        return this.modelValue || null;
      },
      set: function set(newVal) {
        this.$emit("update:modelValue", newVal);
      }
    },
    textIsValue: function textIsValue() {
      return this._valueField === this.textField;
    }
  },
  methods: {
    setQueryStringFromModelValue: function setQueryStringFromModelValue() {
      if (this._valueField == this.textField) this.queryString = this.selected; // TODO: this scenario isn't fully test yet
      else this.setQueryFromValue(this.selected);
    },
    display: function display(option) {
      return option[this.textField];
    },
    value: function value(option) {
      if (this.codeAsValue) return option.code;
      if (this.nameAsValue) return option.name;
      return option[this._valueField];
    },
    query: debounce(function () {
      var that = this;
      var val = this.queryString;
      if (this.abortController) this.abortController.abort();

      if (!val || val.length < 3) {
        this.queryResults = [];
        this.isLoading = false;
        this.selected = val;
        return;
      }

      if (this.textIsValue) this.selected = val;
      this.isLoading = true;
      this.abortController = this.api.getAbortController();
      this.queryFn(val).then(function (content) {
        that.queryResults = content.slice(0, 10);
      }).finally(function () {
        return that.isLoading = false;
      });
    }, 500),
    setQueryFromValue: function setQueryFromValue(val) {
      if (!getFn) {
        console.error("autoComplete does not have getFn defined. Unable to fetch option");
        return;
      }

      var that = this;
      this.isLoading = true;
      this.getFn(val).then(function (option) {
        that.select(option);
      }).finally(function () {
        return that.isLoading = false;
      });
    },
    select: function select(option) {
      this.queryResults = [];
      this.queryString = this.display(option);
      this.selected = this.value(option);
      this.$emit("selected", option);
    },
    delayedBlur: function delayedBlur() {
      var that = this;
      delay(function () {
        return that.hasFocus = false;
      }, 200);
    }
  }
});

var _withId$8 = /*#__PURE__*/withScopeId("data-v-628b9e52");

pushScopeId("data-v-628b9e52");

var _hoisted_1$k = {
  key: 0,
  class: "results is-bordered"
};
var _hoisted_2$i = {
  class: "table is-hoverable"
};

popScopeId();

var render$r = /*#__PURE__*/_withId$8(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_loading = resolveComponent("loading");

  return openBlock(), createBlock(Fragment, null, [withDirectives(createVNode("input", {
    type: "text",
    placeholder: _ctx.placeholder,
    autocomplete: "chrome-off",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.queryString = $event;
    }),
    onInput: _cache[2] || (_cache[2] = function () {
      return _ctx.query && _ctx.query.apply(_ctx, arguments);
    }),
    onFocus: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.hasFocus = true;
    }),
    onBlur: _cache[4] || (_cache[4] = function () {
      return _ctx.delayedBlur && _ctx.delayedBlur.apply(_ctx, arguments);
    }),
    class: "input",
    id: _ctx._id
  }, null, 40, ["placeholder", "id"]), [[vModelText, _ctx.queryString]]), createVNode("input", {
    type: "hidden",
    name: _ctx.name,
    value: _ctx.selected
  }, null, 8, ["name", "value"]), withDirectives(createVNode(_component_loading, null, null, 512), [[vShow, _ctx.isLoading]]), _ctx.showResults ? (openBlock(), createBlock("div", _hoisted_1$k, [createVNode("table", _hoisted_2$i, [createVNode("tbody", null, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.queryResults, function (x) {
    return openBlock(), createBlock("tr", {
      key: _ctx.value(x),
      onClick: function onClick($event) {
        return _ctx.select(x);
      }
    }, [createVNode("td", null, toDisplayString(_ctx.display(x)), 1)], 8, ["onClick"]);
  }), 128))])])])) : createCommentVNode("", true)], 64);
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$h = "\n.results[data-v-628b9e52] {\r\n    position: absolute;\r\n    z-index: 100;\r\n    padding: 5px;\r\n    cursor: pointer;\r\n    max-height: 200px;\r\n    overflow: auto;\r\n    overflow-y: auto;\r\n    background-color: white;\r\n    width: 100%;\n}\r\n";
styleInject(css_248z$h);

script$r.render = render$r;
script$r.__scopeId = "data-v-628b9e52";

var useHash = "production" !== 'development';
var utils = {
  keys: function keys(obj) {
    if (obj === undefined) {
      return null;
    }

    return Object.keys(obj);
  },
  getFromArrayById: function getFromArrayById(arr, id) {
    var filtered = this.keys(arr).filter(function (x) {
      return arr[x].id === id;
    });
    var rtn = [];
    filtered.forEach(function (x) {
      return rtn.push(arr[x]);
    });
    return rtn;
  },
  getFirstFromArrayById: function getFirstFromArrayById(arr, id) {
    var filtered = this.keys(arr).filter(function (x) {
      return arr[x].id === id;
    });
    return arr[filtered[0]];
  },
  toBase64: function toBase64(string) {
    return btoa(string);
  },
  fromBase64: function fromBase64(string) {
    return atob(string);
  },
  toCache: function toCache(key, data, persistent) {
    if (!data) return;
    var cacheKey = useHash ? this.toBase64(key) : key;
    var json = JSON.stringify(data);
    var cache = useHash ? this.toBase64(json) : json;
    persistent ? localStorage.setItem(cacheKey, cache) : sessionStorage.setItem(cacheKey, cache);
  },
  fromCache: function fromCache(key, persistent) {
    var cacheKey = useHash ? this.toBase64(key) : key;
    var cache = persistent ? localStorage.getItem(cacheKey) : sessionStorage.getItem(cacheKey);
    if (!cache) return null;
    var json = useHash ? this.fromBase64(cache) : cache;
    return JSON.parse(json);
  },
  deleteCache: function deleteCache(key, persistent) {
    var cacheKey = useHash ? this.toBase64(key) : key;
    if (persistent) localStorage.removeItem(cacheKey);else sessionStorage.removeItem(cacheKey);
  },
  toArray: function toArray(obj) {
    var result = [];
    Object.keys(obj).forEach(function (key) {
      result.push(obj[key]);
    });
    return result;
  },
  isFramed: function isFramed() {
    return parent.length > 0;
  },
  toShortDate: function toShortDate(value) {
    if (!value) return '';
    var dt;
    if (value instanceof Date) dt = DateTime.fromJSDate(value);else dt = DateTime.fromISO(value);
    if (dt.invalid) dt = DateTime.fromObject(value);
    return dt.toLocaleString(DateTime.DATE_SHORT);
  },
  getFormData: function getFormData(formElement) {
    var object = {};
    var formData = new FormData(formElement);
    formData.forEach(function (value, key) {
      if (!Reflect.has(object, key)) object[key] = value;else if (!Array.isArray(object[key])) object[key] = [object[key]];else object[key].push(value);
    });
    return object;
  },
  // https://thewebdev.info/2021/04/17/how-to-convert-any-string-into-camel-case-with-javascript/
  camelize: function camelize(str) {
    return str.replace(/(?:^\w|\[A-Z\]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  },
  stripTimeFromDate: function stripTimeFromDate(dateTime) {
    if (!dateTime) {
      return null;
    }

    return new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate());
  },
  getNestedValue: function getNestedValue(fieldName, dataItem) {
    if (!fieldName) {
      return "";
    }

    var path = fieldName.split(".");
    var data = dataItem;
    path.forEach(function (pathSection) {
      return data = data ? data[pathSection] : undefined;
    });
    return data;
  },
  getFormatedDate: function getFormatedDate(fieldName, dataItem, dateTimeFormat) {
    return DateTime.fromJSDate(new Date(dataItem[fieldName])).toFormat(dateTimeFormat);
  },
  // Credits: https://stackoverflow.com/a/2117523
  getGuid: function getGuid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
      return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
  }
};

var JsonClient = /*#__PURE__*/function () {
  function JsonClient(baseAddress) {
    _classCallCheck(this, JsonClient);

    this.root = baseAddress;
  }
  /*
   * "public" methods
   */


  _createClass(JsonClient, [{
    key: "setToken",
    value: function setToken(token) {
      this.bearer = token;
    }
  }, {
    key: "getAbortController",
    value: function getAbortController() {
      var controller = new AbortController();
      this.abortSignal = controller.signal;
      return controller;
    }
  }, {
    key: "get",
    value: function get(path, id, query) {
      this.setUrl(path, id, query);
      this.withHeaders().withOptions('get');
      return fetch(this.url, this.options).then(this.jsonResponse).catch(this.errorResponse);
    }
  }, {
    key: "getCache",
    value: function getCache(path, id) {
      this.setUrl(path, id);
      var key = this.url;
      var cache = utils.fromCache(key);
      if (cache) return new Promise(function (resolve) {
        return resolve(cache);
      });
      return this.get(path, id).then(function (content) {
        utils.toCache(key, content);
        return content;
      });
    }
  }, {
    key: "clearCache",
    value: function clearCache(path, id) {
      this.setUrl(path, id);
      var key = this.url;
      utils.deleteCache(key);
    }
  }, {
    key: "post",
    value: function post(data, path) {
      this.setUrl(path);
      return this.submit(data, 'post');
    }
  }, {
    key: "put",
    value: function put(data, path) {
      this.setUrl(path);
      return this.submit(data, 'put');
    }
  }, {
    key: "patch",
    value: function patch(data, path) {
      this.setUrl(path);
      return this.submit(data, 'PATCH');
    }
  }, {
    key: "delete",
    value: function _delete(id, path) {
      this.setUrl(path);
      return this.submit(id, 'delete');
    }
    /*
     * "private" methods
     */

  }, {
    key: "setUrl",
    value: function setUrl(path, id, query) {
      path = path === undefined ? '' : "/".concat(path);
      id = id === undefined ? '' : "/".concat(id);
      query = query === undefined ? '' : "?".concat(new URLSearchParams(query));
      this.url = "".concat(this.root).concat(path).concat(id).concat(query);
    }
  }, {
    key: "submit",
    value: function submit(data, method) {
      this.withHeaders().withOptions(method);
      this.options.body = JSON.stringify(data);
      return fetch(this.url, this.options).then(this.jsonResponse).catch(this.errorResponse);
    }
    /*
     * fetch setup
     */

  }, {
    key: "withHeaders",
    value: function withHeaders() {
      this.headers = new Headers({
        'content-type': 'application/json'
      });
      if (this.bearer && this.bearer.length > 0) this.headers.append('Authorization', "Bearer ".concat(this.bearer));
      var impersonate = sessionStorage.getItem('impersonate');
      if (impersonate && impersonate.length > 0) this.headers.append('X-Impersonate', impersonate);
      return this;
    }
  }, {
    key: "withOptions",
    value: function withOptions(method) {
      this.options = {
        method: method,
        headers: this.headers,
        credentials: 'include'
      };
      if (this.abortSignal) this.options.signal = this.abortSignal;
      return this;
    }
    /*
     * response handling
     */

  }, {
    key: "jsonResponse",
    value: function jsonResponse(response) {
      apiClientUtils.reportImpersonation(response);
      if (response.status === 204) return response.statusText;

      if (response.ok) {
        var contentType = response.headers.get("content-type"); // in case of json response, return json

        if (contentType && ~contentType.indexOf("application/json")) {
          return response.json(); // in case of octet-stream, return the whole response
        } else if (contentType && ~contentType.indexOf("application/octet-stream")) {
          return response; // otherwise, return body
        } else {
          return response.text();
        }
      }

      return Promise.reject(response);
    }
  }, {
    key: "errorResponse",
    value: function errorResponse(response) {
      apiClientUtils.reportImpersonation(response);
      return apiClientUtils.remoteErrorMessage(response);
    }
  }]);

  return JsonClient;
}();

var apiClientUtils = {
  reportImpersonation: function reportImpersonation(response) {
    if (!response.headers) return;
    var impersonation = response.headers.get('X-Impersonating');

    if (impersonation && impersonation.length > 0) {
      utils.toCache('impersonating', impersonation);
    } else {
      utils.deleteCache('impersonating');
    }
  },
  remoteErrorMessage: function remoteErrorMessage(response) {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var rtn, contentType, err, message, returnedRequestId, requestId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(response instanceof TypeError)) {
                _context.next = 4;
                break;
              }

              rtn = {
                message: response.message,
                error: 'TypeError'
              };
              _context.next = 22;
              break;

            case 4:
              contentType = response.headers.get('content-type') ? response.headers.get('content-type').split(';')[0] : '';
              _context.t0 = contentType;
              _context.next = _context.t0 === 'application/json' ? 8 : _context.t0 === 'application/problem+json' ? 12 : 21;
              break;

            case 8:
              _context.next = 10;
              return response.json();

            case 10:
              rtn = _context.sent;
              return _context.abrupt("break", 22);

            case 12:
              _context.next = 14;
              return response.json();

            case 14:
              err = _context.sent;
              message = "";

              if (err.errors) {
                message = utils.keys(err.errors).map(function (x) {
                  return err.errors[x].join('\r\n').replace(/, line \d*.*position \d*./gm, '.');
                }).join('\r\n');
              }

              returnedRequestId = err.requestId ? err.requestId : err.traceId;
              requestId = returnedRequestId.replace('|', '');
              rtn = {
                message: message,
                error: err.title,
                statusCode: response.status,
                requestId: requestId,
                statusDescription: response.statusText
              };
              return _context.abrupt("break", 22);

            case 21:
              rtn = {
                message: 'An error was received from the server with an unrecognized content type',
                error: contentType
              };

            case 22:
              return _context.abrupt("return", Promise.reject(rtn));

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};
var JsonClient$1 = JsonClient;

var installOnApp = function installOnApp(app, name, fn) {
  app.config.globalProperties[name] = fn;
  app.provide(name, fn);
};

var plugin$3 = {
  install: function install(app) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!options) throw 'Options are required to install plugin';
    _store$2 = options.store;
    _namespace$1 = options.namespace;
    init(options.config);
    installOnApp(app, '$signIn', function () {
      return signIn(options.tokenRequest);
    });
    installOnApp(app, '$logout', logout);
    installOnApp(app, '$accessToken', function () {
      return getAccessToken(options.tokenRequest);
    });
  }
};

var signIn = function signIn(tokenRequest) {
  setState(tokenRequest);
  tokenRequest.pkce = true;

  _authClient.token.getWithRedirect(tokenRequest);
};

var logout = function logout() {
  _authClient.stop();

  return _authClient.signOut();
};

var getAccessToken = function getAccessToken(tokenRequest) {
  return _authClient.tokenManager.get('accessToken').then(function (_ref) {
    var accessToken = _ref.accessToken;
    return new Promise(function (resolve) {
      return resolve(accessToken);
    });
  });
};

var _authClient;

var _store$2;

var _namespace$1;

var _roleClaimType;

var init = function init(config) {
  _roleClaimType = config.roleClaimType;
  config.tokenManager = {
    autoRenew: true
  };
  _authClient = new okta.OktaAuth(config);

  _authClient.start();

  if (_authClient.isLoginRedirect()) parseTokens();else retrieveToken();
};

var setState = function setState(tokenRequest) {
  var state = {
    startUrl: window.location.href
  };
  var str = JSON.stringify(state);
  var based = btoa(str);
  tokenRequest.state = based;
};

var parseTokens = function parseTokens() {
  _authClient.token.parseFromUrl().then(function (_ref2) {
    var tokens = _ref2.tokens;

    _authClient.tokenManager.setTokens(tokens);

    var state = getStateFromUrl();
    redirectToStartPage(state);
  });
};

var retrieveToken = function retrieveToken() {
  _authClient.tokenManager.get('idToken').then(function (idToken) {
    if (!idToken || _authClient.tokenManager.hasExpired(idToken)) return;
    setUserDetailsInStore(idToken.claims);
  });
};

var getStateFromUrl = function getStateFromUrl() {
  var queryString = window.location.search;
  var urlParams = new URLSearchParams(queryString);
  return urlParams.get('state');
};

var redirectToStartPage = function redirectToStartPage(based) {
  var str = atob(based);
  var state = JSON.parse(str);
  window.location.href = state.startUrl;
};

var setUserDetailsInStore = function setUserDetailsInStore(tokenClaims) {
  _store$2.commit("".concat(_namespace$1, "/setUserName"), tokenClaims.preferred_username);

  _store$2.commit("".concat(_namespace$1, "/setName"), tokenClaims.name);

  _store$2.commit("".concat(_namespace$1, "/setEmail"), tokenClaims.email);

  _store$2.commit("".concat(_namespace$1, "/setRoles"), clearAuthClaimPrefix(tokenClaims));

  _store$2.commit("".concat(_namespace$1, "/setApps"), isolateAppName(tokenClaims.apps));
};

function clearAuthClaimPrefix(tokenClaims) {
  if (tokenClaims && tokenClaims[_roleClaimType] && tokenClaims[_roleClaimType].length) {
    var prefix = "_".concat(_roleClaimType, "-");
    return tokenClaims[_roleClaimType].map(function (claim) {
      if (claim.startsWith(prefix)) {
        return claim.substring(prefix.length);
      }

      return claim;
    });
  }
}

function isolateAppName(apps) {
  if (!apps) return;
  return apps.map(function (app) {
    return app.replaceAll(/\s?(Allegro|Users|eBiz|All)\s?/gi, '');
  }).filter(function (i) {
    return i !== '';
  });
}

function getNamespace() {
  return _namespace$1;
}

var state$2 = function state() {
  return {
    userName: null,
    name: null,
    email: null,
    roles: null,
    apps: null
  };
};

var getters$2 = {
  isAuthenticated: function isAuthenticated(s) {
    return s.userName != null;
  },
  hasRole: function hasRole(s) {
    return function (role) {
      return (s.roles || []).indexOf(role) > -1;
    };
  }
};
var mutations$2 = {
  setUserName: function setUserName(s, userName) {
    s.userName = userName;
  },
  setName: function setName(s, name) {
    s.name = name;
  },
  setEmail: function setEmail(s, email) {
    s.email = email;
  },
  setRoles: function setRoles(s, roles) {
    s.roles = roles;
  },
  setApps: function setApps(s, apps) {
    s.apps = apps;
  }
};
var store$1 = {
  namespaced: true,
  state: state$2,
  getters: getters$2,
  mutations: mutations$2
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  plugin: plugin$3,
  getNamespace: getNamespace,
  store: store$1
});

var script$q = defineComponent({
  name: 'modal-error',
  components: {
    modalCard: script$4$1
  },
  props: {
    isAllegroUser: {
      type: Boolean,
      required: false
    },
    supportEmail: {
      type: String,
      default: ""
    }
  },
  computed: _objectSpread2$1(_objectSpread2$1({}, mapGetters(['error'])), {}, {
    statusText: function statusText() {
      return this.error && this.error.statusDescription || '';
    },
    errorMessage: function errorMessage() {
      return this.error && "".concat(this.error.statusCode || '', " - ").concat(this.error.message || '');
    },
    requestId: function requestId() {
      return this.error && this.error.requestId || '';
    },
    hasError: function hasError() {
      return Boolean(this.error);
    },
    hrefSupportEmail: function hrefSupportEmail() {
      return "mailto:".concat(this.supportEmail);
    }
  }),
  methods: {
    close: function close() {
      this.$store.commit('closeErrorModal');
      this.$emit('closed');
    }
  }
});

var _hoisted_1$j = {
  class: "error-message"
};
var _hoisted_2$h = {
  key: 0
};
var _hoisted_3$d = {
  key: 1
};

var _hoisted_4$9 = /*#__PURE__*/createTextVNode("If the issue persists, please copy this error message and send email to ");

var _hoisted_5$7 = {
  class: "buttons"
};
function render$q(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_modal_card = resolveComponent("modal-card");

  return openBlock(), createBlock(_component_modal_card, {
    active: _ctx.hasError,
    class: "is-error"
  }, {
    title: withCtx(function () {
      return [createTextVNode(toDisplayString(_ctx.statusText), 1)];
    }),
    body: withCtx(function () {
      return [createVNode("p", _hoisted_1$j, toDisplayString(_ctx.errorMessage), 1), _ctx.isAllegroUser ? (openBlock(), createBlock("p", _hoisted_2$h, "If the issue persists, please copy this error message AND Request Id into a Service Desk Ticket")) : (openBlock(), createBlock("p", _hoisted_3$d, [_hoisted_4$9, createVNode("a", {
        href: _ctx.hrefSupportEmail
      }, toDisplayString(_ctx.supportEmail), 9, ["href"])]))];
    }),
    foot: withCtx(function () {
      return [createVNode("p", null, " Request Id: " + toDisplayString(_ctx.requestId), 1), createVNode("div", _hoisted_5$7, [createVNode("button", {
        onClick: _cache[1] || (_cache[1] = function () {
          return _ctx.close && _ctx.close.apply(_ctx, arguments);
        })
      }, "Close")])];
    }),
    _: 1
  }, 8, ["active"]);
}

var css_248z$g = "\n.modal.is-error .modal-body {\r\n  width: 800px;\n}\r\n";
styleInject(css_248z$g);

script$q.render = render$q;

var DEFAULT_DURATION = 5000;
setDefaults({
  duration: DEFAULT_DURATION,
  position: 'bottom-right',
  closeOnClick: false,
  dismissible: true,
  animate: {
    in: 'fadeIn',
    out: 'fadeOut'
  }
});

var toast = function toast(_ref) {
  var message = _ref.message,
      type = _ref.type,
      duration = _ref.duration;
  toast$2({
    message: message,
    type: "is-".concat(type),
    duration: duration | DEFAULT_DURATION
  });
};

var toast$1 = toast;

var _store$1;

var _router;

var plugin$2 = {
  install: function install(app) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!options) throw 'Options are required to install plugin';
    app.component(script$q.name, script$q);
    _store$1 = options.store;
    _router = options.router;
    options.namespace || 'error';
    installOnApp(app, '$error', showErrorToast);
    installOnApp(app, '$errorModal', showErrorModal);
    installOnApp(app, '$errorPage', showErrorPage);
    installOnApp(app, '$warning', showWarningToast);
  }
};

var showErrorToast = function showErrorToast(err) {
  toast$1({
    message: err.message,
    type: 'danger',
    duration: Math.pow(2, 31) - 1
  });
};

var showWarningToast = function showWarningToast(err) {
  toast$1({
    message: err.message,
    type: 'warning',
    dismissible: true,
    position: 'bottom-right',
    duration: 5000,
    animate: {
      in: 'fadeIn',
      out: 'fadeOut'
    }
  });
};

var showErrorModal = function showErrorModal(err) {
  _store$1.commit('showErrorModal', err);
};

var showErrorPage = function showErrorPage(err) {
  err.originalUrl = _router.currentRoute.value.path;

  _router.push({
    name: 'Error',
    params: err
  });
};

// https://next.vuex.vuejs.org/guide/state.html
var state$1 = function state() {
  return {
    showErrorModal: null
  };
}; // https://next.vuex.vuejs.org/guide/getters.html
// (state, getters)


var getters$1 = {
  error: function error(s) {
    return s.showErrorModal;
  }
}; // https://next.vuex.vuejs.org/guide/mutations.html
// (state, payload)

var mutations$1 = {
  showErrorModal: function showErrorModal(s, payload) {
    s.showErrorModal = payload;
  },
  closeErrorModal: function closeErrorModal(s) {
    s.showErrorModal = null;
  }
}; // https://next.vuex.vuejs.org/guide/actions.html
// ({ state, getters, commit, dispatch }, payload)
// MUST be async
// return new Promise((resolve, reject) => { });
// or async/await

var actions$1 = {};
var store = {
  namespaced: false,
  state: state$1,
  getters: getters$1,
  mutations: mutations$1,
  actions: actions$1
};

var script$p = defineComponent({
  name: "error-page",
  data: function data() {
    return {
      error: this.$route.params.error,
      message: this.$route.params.message,
      originalUrl: this.$route.params.originalUrl,
      isAllegroUser: this.$route.params.isAllegroUser,
      supportEmail: this.$route.params.supportEmail,
      requestId: this.$route.params.requestId,
      statusCode: this.$route.params.statusCode,
      statusDescription: this.$route.params.statusDescription,
      type: this.$route.params.type
    };
  },
  computed: {
    errorClass: function errorClass() {
      if (!this.statusCode) return;
      return Math.floor(this.statusCode / 100);
    },
    showMessage: function showMessage() {
      return this.statusDescription != this.message;
    },
    hrefSupportEmail: function hrefSupportEmail() {
      return "mailto:".concat(this.supportEmail);
    },
    clientErrorTitle: function clientErrorTitle() {
      switch (Number(this.statusCode)) {
        case 403:
          return "Unauthorized";

        case 404:
          return "Page not found";

        default:
          return "Client Error";
      }
    },
    errorTitle: function errorTitle() {
      switch (this.errorClass) {
        case 5:
          return "Server Error";

        case 4:
          return this.clientErrorTitle;

        default:
          return "";
      }
    },
    unauthorizedInstructions: function unauthorizedInstructions() {
      return this.isAllegroUser ? "If you think you should have access here, please open a ticket via Service Desk." : "If you think you should have access here, please request access to this page via email to: <a href=\"".concat(this.hrefSupportEmail, "\">").concat(this.supportEmail, "</a>");
    },
    errorInstructions: function errorInstructions() {
      return this.isAllegroUser ? "If the issue persists, please copy the above into a Service Desk ticket." : "If the issue persists, please copy the above and send email to: <a href=\"".concat(this.hrefSupportEmail, "\"> ").concat(this.supportEmail, "</a>");
    }
  },
  created: function created() {// TODO: bus.$emit('loading', 'done');
  }
});

var _withId$7 = /*#__PURE__*/withScopeId("data-v-4cc5ae58");

pushScopeId("data-v-4cc5ae58");

var _hoisted_1$i = {
  class: "container"
};
var _hoisted_2$g = {
  class: "tile is-ancestor"
};
var _hoisted_3$c = {
  class: "tile is-vertical"
};
var _hoisted_4$8 = {
  class: "tile",
  style: {
    "justify-content": "center"
  }
};
var _hoisted_5$6 = {
  class: "tile is-parent is-4"
};
var _hoisted_6$4 = {
  class: "tile is-child is-flex is-vcentered"
};
var _hoisted_7$4 = {
  class: "is-centered no-wrap",
  style: {
    "font-size": "150px"
  }
};
var _hoisted_8$4 = {
  class: "tile is-parent is-6"
};
var _hoisted_9$4 = {
  class: "tile is-child is-flex is-vcentered"
};
var _hoisted_10$2 = {
  class: "is-centered",
  style: {
    "font-size": "75px"
  }
};
var _hoisted_11$2 = {
  key: 0,
  class: "tile is-parent is-centered"
};
var _hoisted_12$2 = {
  class: "tile is-child"
};
var _hoisted_13$2 = {
  class: "message is-danger"
};
var _hoisted_14$1 = {
  class: "message-body"
};
var _hoisted_15$1 = {
  class: "is-horizontal"
};
var _hoisted_16 = {
  key: 0
};
var _hoisted_17 = {
  key: 1
};

var _hoisted_18 = /*#__PURE__*/createVNode("dt", null, "Request Id", -1);

var _hoisted_19 = /*#__PURE__*/createVNode("dt", null, "Original Url", -1);

var _hoisted_20 = {
  class: "tile is-parent",
  style: {
    "justify-content": "center"
  }
};
var _hoisted_21 = {
  class: "tile is-child is-6"
};

var _hoisted_22 = /*#__PURE__*/createTextVNode(" It seems you don't have access to: ");

var _hoisted_23 = {
  key: 1
};

var _hoisted_24 = /*#__PURE__*/createTextVNode(" The network connection between you and us was made successfully but the web server could not find the requested page, file, or resource. This error most commonly occurs when an incorrect URL is entered, a link is outdated, or we improperly moved things on you. ");

var _hoisted_25 = /*#__PURE__*/createVNode("br", null, null, -1);

var _hoisted_26 = /*#__PURE__*/createTextVNode(" Please verify the URL to address this problem. ");

var _hoisted_27 = {
  key: 2
};

popScopeId();

var render$p = /*#__PURE__*/_withId$7(function (_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", null, [createVNode("div", _hoisted_1$i, [createVNode("main", null, [createVNode("div", _hoisted_2$g, [createVNode("div", _hoisted_3$c, [createVNode("div", _hoisted_4$8, [createVNode("div", _hoisted_5$6, [createVNode("div", _hoisted_6$4, [createVNode("h1", _hoisted_7$4, toDisplayString(_ctx.statusCode), 1)])]), createVNode("div", _hoisted_8$4, [createVNode("div", _hoisted_9$4, [createVNode("h2", _hoisted_10$2, toDisplayString(_ctx.statusDescription), 1)])])]), _ctx.showMessage ? (openBlock(), createBlock("div", _hoisted_11$2, [createVNode("div", _hoisted_12$2, [createVNode("article", _hoisted_13$2, [createVNode("div", _hoisted_14$1, [createVNode("dl", _hoisted_15$1, [_ctx.message ? (openBlock(), createBlock("dt", _hoisted_16, "Error")) : createCommentVNode("", true), createVNode("dd", null, toDisplayString(_ctx.message), 1), _ctx.type ? (openBlock(), createBlock("dt", _hoisted_17, "Type")) : createCommentVNode("", true), createVNode("dd", null, toDisplayString(_ctx.type), 1), _hoisted_18, createVNode("dd", null, toDisplayString(_ctx.requestId), 1), _hoisted_19, createVNode("dd", null, toDisplayString(_ctx.originalUrl), 1)]), createVNode("p", {
    innerHTML: _ctx.errorInstructions,
    class: "pushed-down"
  }, null, 8, ["innerHTML"])])])])])) : createCommentVNode("", true), createVNode("div", _hoisted_20, [createVNode("div", _hoisted_21, [createVNode("h3", null, toDisplayString(_ctx.errorTitle), 1), _ctx.statusCode == 403 ? (openBlock(), createBlock(Fragment, {
    key: 0
  }, [createVNode("p", null, [_hoisted_22, createVNode("b", null, toDisplayString(_ctx.originalUrl), 1)]), createVNode("p", {
    innerHTML: _ctx.unauthorizedInstructions,
    class: "pushed-down"
  }, null, 8, ["innerHTML"])], 64)) : _ctx.errorClass === 4 ? (openBlock(), createBlock("p", _hoisted_23, [_hoisted_24, _hoisted_25, _hoisted_26])) : _ctx.errorClass === 5 ? (openBlock(), createBlock("p", _hoisted_27, "We are unable to process your request due to glitchy squirrels or unexpected conditions.")) : createCommentVNode("", true)])])])])])])]);
});

var css_248z$f = "\ndt[data-v-4cc5ae58] {\r\n  font-weight: bold;\r\n  float: left;\r\n  margin-right: 1rem;\n}\n.pushed-down[data-v-4cc5ae58] {\r\n  margin-top: 1.5rem;\n}\r\n";
styleInject(css_248z$f);

script$p.render = render$p;
script$p.__scopeId = "data-v-4cc5ae58";

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  plugin: plugin$2,
  store: store,
  page: script$p
});

// https://next.vuex.vuejs.org/guide/state.html
var state = function state() {
  return {
    validations: []
  };
}; // https://next.vuex.vuejs.org/guide/getters.html
// (state, getters)


var getters = {}; // https://next.vuex.vuejs.org/guide/mutations.html
// (state, payload)

var mutations = {
  addValidation: function addValidation(s, fn) {
    if (s.validations.indexOf(fn) < 0) s.validations.push(fn);
  },
  removeValidation: function removeValidation(s, fn) {
    var index = s.validations.indexOf(fn);

    if (index > -1) {
      s.validations.splice(index, 1);
    }
  }
}; // https://next.vuex.vuejs.org/guide/actions.html
// ({ state, getters, commit, dispatch }, payload)

var actions = {
  validate: function validate(_ref, errors) {
    var state = _ref.state;
    if (!errors) errors = [];
    var validations = state.validations;
    validations.forEach(function (validation) {
      var error = validation();
      if (!error) errors.push(error);
    });
  }
};
var formValidationStore = {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};

var script$o = defineComponent({
  name: 'field-validate',
  props: {
    for: {
      type: String,
      required: true
    },
    decorate: {
      type: String,
      required: false
    },
    required: Boolean,
    requiredFn: Function,
    validationFn: Function,
    maxLength: Number,
    minValue: Number,
    maxValue: Number,
    // Use in case validated model is different from input value
    validationModel: {
      type: [String, Boolean, Number, Object],
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      label: null,
      error: null,
      init: false,
      formId: null
    };
  },
  watch: {
    error: function error(newVal, oldVal) {
      var field = this.getDecorateField();
      if (newVal && !oldVal) field.classList.add('is-danger');else if (!newVal && oldVal) field.classList.remove('is-danger');
    }
  },
  mounted: function mounted() {
    var field = this.getDecorateField();
    field.addEventListener('blur', this.handleBlur);
    field.addEventListener('change', this.handleChange);
    this.label = this.getLabel();
    this.formId = this.getForm().id;
    if (!this.formId) throw Error("Form used with field-validate component must have an Id.");
    this.ensureModuleExists(this.formId);
    this.$store.commit("".concat(namespace(), "/").concat(this.formId, "/addValidation"), this.validate);
    this.init = true;
  },
  unmounted: function unmounted() {
    this.$store.commit("".concat(namespace(), "/").concat(this.formId, "/removeValidation"), this.validate);
  },
  methods: {
    getField: function getField() {
      var form = this.getForm();
      return form.elements[this.for];
    },
    getForm: function getForm() {
      return this.$el.closest('form');
    },
    getDecorateField: function getDecorateField() {
      if (this.decorate) return document.querySelectorAll("#".concat(this.decorate))[0];else return this.getField();
    },
    getLabel: function getLabel() {
      var labelEl = document.querySelectorAll("label[for=".concat(this.for))[0];

      if (!labelEl) {
        var field = this.$el.closest('.field');
        labelEl = field.querySelectorAll('label')[0];
      }

      if (!labelEl) return;
      return labelEl.innerText;
    },
    getValue: function getValue() {
      return this.useValidationModel ? this.validationModel : this.getField().value;
    },
    handleBlur: function handleBlur() {
      delay(this.validate, 200);
    },
    handleChange: function handleChange() {
      if (!this.error) return;
      delay(this.validate, 200);
    },
    validate: function validate() {
      var val = this.getValue();
      var label = this.label;
      var error = null;

      if (this.required && !val || this.requiredFn && this.requiredFn() && !val) {
        error = "".concat(label, " is required.");
      } else if (this.maxLength && val.length > this.maxLength) {
        error = "".concat(label, " cannot have more than ").concat(this.maxLength, " characters.");
      } else if (typeof this.minValue === 'number' && val < this.minValue) {
        error = "".concat(label, " must be greater than or equal to ").concat(this.minValue, ".");
      } else if (typeof this.maxValue === 'number' && val > this.maxValue) {
        error = "".concat(label, " must be less than or equal to ").concat(this.maxValue, ".");
      } else if (this.validationFn) {
        var errorMessage = this.validationFn(val); // if we have errorMessage, then validation is failed and errorMessage is returned.

        if (typeof errorMessage === "string") {
          error = errorMessage;
        }
      }

      this.error = error;
      return error;
    },
    ensureModuleExists: function ensureModuleExists() {
      if (this.$store.hasModule([namespace(), this.formId])) return;
      this.$store.registerModule([namespace(), this.formId], formValidationStore);
    }
  },
  computed: {
    // Use validationModel only if it was really passed from parent
    useValidationModel: function useValidationModel() {
      return this.validationModel !== undefined;
    }
  }
});

var _hoisted_1$h = {
  key: 0,
  class: "help is-danger"
};
function render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", null, [_ctx.error ? (openBlock(), createBlock("p", _hoisted_1$h, toDisplayString(_ctx.error), 1)) : createCommentVNode("", true)]);
}

script$o.render = render$o;

var _store;

var _namespace;

var plugin$1 = {
  install: function install(app) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!options) throw 'Options are required to install plugin';
    app.component(script$o.name, script$o);
    _store = options.store;
    _namespace = options.namespace || 'formValidation';
    installOnApp(app, '$validate', function (formId) {
      return validate(formId, _store);
    });
  }
};
var namespace = function namespace() {
  return _namespace;
};

var validate = function validate(formId, store) {
  if (!formId) throw Error("Form Id must be provided for $validate method.");
  var errors = [];
  var state = store.state[_namespace][formId];
  var validations = state.validations;
  validations.forEach(function (validation) {
    var error = validation();
    if (error) errors.push(error);
  });
  if (errors.length > 0) window.scrollTo(0, 0);
  return errors;
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  plugin: plugin$1,
  store: formValidationStore
});

var plugin = {
  install: function install(app) {
    installOnApp(app, '$toast', toast$1);
  }
};

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  plugin: plugin
});

var globalApps = [{
  title: 'Order Samples',
  label: 'Samples',
  icon: 'microchip',
  href: '/productionsamples'
}, {
  title: 'Split Commissions',
  label: 'Commissions',
  icon: 'money-check-alt',
  href: '/commissions'
}, {
  title: 'Release to Sales',
  label: 'RTS Products',
  icon: 'question',
  href: '/rts'
}, {
  title: 'Request for Quote',
  label: 'RFQ',
  icon: 'file-invoice-dollar',
  href: '/phoenix',
  order: 2
}, {
  title: 'Sales Plan',
  label: 'Sales Plan',
  icon: 'tasks',
  href: '/prm/sales'
}];
var roleBasedApps = {
  'design registration': {
    title: 'Global Design Registration',
    label: 'Registrations',
    icon: 'file-alt',
    href: "".concat(process.env.VUE_APP_DESIGN_REG_URL),
    order: 1
  }
};
var ebizApps = {
  getAssignedApps: function getAssignedApps() {
    var namespace = getNamespace();
    var userApps = this.$store.state[namespace].apps;
    return userApps;
  },
  getUserApps: function getUserApps() {
    var userApps = this.getAssignedApps();
    var rtn = userApps.reduce(function (result, userApp) {
      var key = userApp.toLowerCase();
      var app = roleBasedApps[key];
      if (!app) return result;
      result.push(app);
      return result;
    }, []);
    return rtn.concat(globalApps).sort(function (a, b) {
      if (!a.order) return 1;
      if (!b.order) return -1;
      return a.order - b.order;
    });
  }
};

var script$n = defineComponent({
  name: "confirmFileDeleteDialog",
  components: {
    modalCard: script$4$1
  },
  emits: ["done"],
  props: {
    isVisible: Boolean,
    fileName: String
  },
  methods: {
    done: function done(proceed) {
      this.$emit("done", proceed);
    }
  }
});

var _hoisted_1$g = /*#__PURE__*/createTextVNode("Permanently delete the file?");

var _hoisted_2$f = /*#__PURE__*/createTextVNode(" will be deleted.");

var _hoisted_3$b = /*#__PURE__*/createVNode("div", null, "This operation cannot be undone.", -1);

var _hoisted_4$7 = {
  class: "buttons"
};
function render$n(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_modal_card = resolveComponent("modal-card");

  return openBlock(), createBlock(_component_modal_card, {
    active: _ctx.isVisible
  }, {
    title: withCtx(function () {
      return [_hoisted_1$g];
    }),
    body: withCtx(function () {
      return [createVNode("div", null, [createVNode("strong", null, toDisplayString(_ctx.fileName), 1), _hoisted_2$f]), _hoisted_3$b];
    }),
    foot: withCtx(function () {
      return [createVNode("div", _hoisted_4$7, [createVNode("button", {
        type: "button",
        class: "is-danger is-light",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.done(true);
        })
      }, "Delete file"), createVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.done(false);
        })
      }, "Cancel")])];
    }),
    _: 1
  }, 8, ["active"]);
}

var css_248z$e = "\r\n\r\n";
styleInject(css_248z$e);

script$n.render = render$n;

var events = {
  updateLoading: 'update:loading',
  success: 'success',
  delete: 'delete',
  error: 'error',
  download: 'download',
  updateFiles: 'update:files'
}; // https://www.telerik.com/kendo-vue-ui/components/upload/api/UploadFileStatus/

var FileStatuses = {
  "UploadFailed": 0,
  "Initial": 1,
  "Selected": 2,
  "Uploading": 3,
  "Uploaded": 4,
  "RemoveFailed": 5,
  "Removing": 6
};
var script$m = defineComponent({
  name: 'fileUpload',
  components: {
    Upload: Upload,
    UploadListSingleItemVue3: UploadListSingleItemVue3,
    loading: script$3$1,
    confirmFileDeleteDialog: script$n
  },
  data: function data() {
    return {
      operationCount: 0,
      newFiles: [],
      headers: null,
      removeFn: null,
      removeUid: null,
      isConfirmFileDeleteDialogVisible: false
    };
  },
  props: {
    name: String,
    asyncSaveUrl: String,
    asyncRemoveUrl: String,
    loading: Boolean,
    files: Array
  },
  emits: _toConsumableArray(Object.values(events)),
  computed: {
    isLoading: function isLoading() {
      return this.operationCount > 0;
    },
    _files: function _files() {
      if (!this.files) return null;
      return this.files.map(function (file) {
        var _file$name, _file$status, _file$extension, _file$uid;

        file.name = (_file$name = file.name) !== null && _file$name !== void 0 ? _file$name : file.fileName;
        file.status = (_file$status = file.status) !== null && _file$status !== void 0 ? _file$status : FileStatuses.Uploaded;
        file.extension = (_file$extension = file.extension) !== null && _file$extension !== void 0 ? _file$extension : ".".concat((file.name || file.fileName).split('.').pop());
        file.uid = (_file$uid = file.uid) !== null && _file$uid !== void 0 ? _file$uid : utils.getGuid();
        return file;
      });
    },
    confirmDeleteFileName: function confirmDeleteFileName() {
      var _this$_files,
          _this$_files$find,
          _this = this;

      return (_this$_files = this._files) === null || _this$_files === void 0 ? void 0 : (_this$_files$find = _this$_files.find(function (file) {
        return file.uid === _this.removeUid;
      })) === null || _this$_files$find === void 0 ? void 0 : _this$_files$find.name;
    }
  },
  watch: {
    isLoading: function isLoading(newVal) {
      this.$emit(events.updateLoading, newVal);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var token;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$accessToken();

            case 2:
              token = _context.sent;
              _this2.headers = {
                Authorization: 'Bearer ' + token
              };

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    onAdd: function onAdd(e) {
      this.operationCount += e.affectedFiles.length;
      this.$emit(events.updateFiles, e.newState);
    },
    confirmOnRemove: function confirmOnRemove(onRemoveFn, uid) {
      this.removeFn = onRemoveFn;
      this.removeUid = uid;
      this.isConfirmFileDeleteDialogVisible = true;
    },
    onRemoveDone: function onRemoveDone(proceed) {
      var _this3 = this;

      if (proceed && this.removeFn) {
        this.$closeModal(function () {
          return _this3.removeFn(_this3.removeUid);
        });
      }

      this.isConfirmFileDeleteDialogVisible = false;
    },
    onRemoved: function onRemoved(e) {
      var _this4 = this;

      e.affectedFiles.forEach(function (a) {
        var _e$response;

        /** If file upload has failed, 
         * delete request is skipped (= onBeforeRemove not triggered) 
         * and operationCount is not increased */
        if (_this4.operationCount > 0) _this4.operationCount--;

        _this4.$emit(events.delete, {
          file: a,
          response: (_e$response = e.response) === null || _e$response === void 0 ? void 0 : _e$response.response
        });
      });
      this.$emit(events.updateFiles, e.newState);
    },
    onBeforeRemove: function onBeforeRemove(e) {
      var _this5 = this;

      this.operationCount += e.files.length;
      var referenceNames = e.files.map(function (f) {
        return _this5.getReferenceName(f.uid);
      });
      e.additionalData = {
        referenceNames: referenceNames
      };
      this.$emit(events.updateFiles, e.newState);
    },
    uploaded: function uploaded(affectedFile, response) {
      this.operationCount--;
      var responseFiles = (response === null || response === void 0 ? void 0 : response.response) || []; // add referenceName to uploaded files

      var responseFile = responseFiles.find(function (r) {
        return r.fileName === affectedFile.name;
      });
      affectedFile.referenceName = responseFile.referenceName;
      this.newFiles.push(affectedFile);
      this.$emit(events.success, affectedFile);
    },
    uploadFailed: function uploadFailed(e) {
      var _e$affectedFiles, _e$response2, _e$response2$response;

      this.operationCount -= (_e$affectedFiles = e.affectedFiles) === null || _e$affectedFiles === void 0 ? void 0 : _e$affectedFiles.length;
      this.$emit(events.error, (_e$response2 = e.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$response = _e$response2.response) === null || _e$response2$response === void 0 ? void 0 : _e$response2$response.data);
    },
    removeFailed: function removeFailed(e, affectedFile) {
      var _e$response3, _e$response3$response;

      this.operationCount--; // Remove file from newState immediately when it was not even uploaded yet

      if (!affectedFile.referenceName) {
        e.newState = event.newState.filter(function (f) {
          return f.uid !== a.uid;
        });
        return;
      }

      this.$emit(events.error, (_e$response3 = e.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$response = _e$response3.response) === null || _e$response3$response === void 0 ? void 0 : _e$response3$response.data);
    },
    getReferenceName: function getReferenceName(uid) {
      var file = this.newFiles.find(function (x) {
        return x.uid === uid;
      }) || this.files.find(function (x) {
        return x.uid === uid;
      });
      return file.referenceName;
    },
    onStatusChange: function onStatusChange(event) {
      var _this6 = this;

      var affected = event.affectedFiles || [];
      affected.forEach(function (a) {
        switch (a.status) {
          case FileStatuses.Uploaded:
            _this6.uploaded(a, event.response);

            break;

          case FileStatuses.UploadFailed:
            _this6.uploadFailed(event);

            break;

          case FileStatuses.RemoveFailed:
            _this6.removeFailed(event, a);
        }
      }); // add prop "fileName" for custom logic

      event.newState.forEach(function (f) {
        return f.fileName = f.name;
      });
      this.$emit(events.updateFiles, event.newState);
    },
    onProgress: function onProgress(event) {
      this.$emit(events.updateFiles, event.newState);
    },
    downloadFiles: function downloadFiles(files) {
      var _this7 = this;

      files.forEach(function (f) {
        return _this7.$emit(events.download, f);
      });
    },
    isDownloadVisible: function isDownloadVisible(files) {
      return files.every(function (f) {
        return f.status === FileStatuses.Uploaded;
      });
    }
  }
});

var _excluded = ["onRemove", "files"];
var _hoisted_1$f = {
  class: "k-file-single file-item-wrapper"
};
var _hoisted_2$e = {
  key: 0,
  class: "k-upload-status"
};

var _hoisted_3$a = /*#__PURE__*/createVNode("span", {
  "aria-label": "Download",
  title: "Download",
  class: "k-icon k-i-download"
}, null, -1);

function render$m(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_UploadListSingleItemVue3 = resolveComponent("UploadListSingleItemVue3");

  var _component_Upload = resolveComponent("Upload");

  var _component_loading = resolveComponent("loading");

  var _component_confirm_file_delete_dialog = resolveComponent("confirm-file-delete-dialog");

  return openBlock(), createBlock("div", null, [createVNode(_component_Upload, {
    list: "fileList",
    "save-headers": _ctx.headers,
    "remove-headers": _ctx.headers,
    files: _ctx._files,
    "remove-method": "DELETE",
    onAdd: _ctx.onAdd,
    onBeforeremove: _ctx.onBeforeRemove,
    onRemove: _ctx.onRemoved,
    onStatuschange: _ctx.onStatusChange,
    onProgress: _ctx.onProgress,
    "save-url": _ctx.asyncSaveUrl,
    "remove-url": _ctx.asyncRemoveUrl,
    class: "file-input-control"
  }, {
    fileList: withCtx(function (_ref) {
      var _ref$props = _ref.props,
          _onRemove = _ref$props.onRemove,
          files = _ref$props.files,
          propsRest = _objectWithoutProperties(_ref$props, _excluded);

      return [createVNode("div", _hoisted_1$f, [createVNode(_component_UploadListSingleItemVue3, mergeProps(propsRest, {
        files: files,
        onRemove: function onRemove($event) {
          return _ctx.confirmOnRemove(_onRemove, $event);
        }
      }), null, 16, ["files", "onRemove"]), _ctx.isDownloadVisible(files) ? (openBlock(), createBlock("strong", _hoisted_2$e, [createVNode("button", {
        onClick: function onClick($event) {
          return _ctx.downloadFiles(files);
        },
        type: "button",
        class: "k-button k-button-icon k-flat"
      }, [_hoisted_3$a], 8, ["onClick"])])) : createCommentVNode("", true)])];
    }),
    _: 1
  }, 8, ["save-headers", "remove-headers", "files", "onAdd", "onBeforeremove", "onRemove", "onStatuschange", "onProgress", "save-url", "remove-url"]), _ctx.isLoading || _ctx.loading ? (openBlock(), createBlock(_component_loading, {
    key: 0,
    class: "for-field"
  })) : createCommentVNode("", true), createVNode(_component_confirm_file_delete_dialog, {
    fileName: _ctx.confirmDeleteFileName,
    onDone: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.onRemoveDone($event);
    }),
    isVisible: _ctx.isConfirmFileDeleteDialogVisible
  }, null, 8, ["fileName", "isVisible"])]);
}

var css_248z$d = "\n.file-input-control input {\r\n  position: absolute !important;\n}\n.file-input-control .k-file {\r\n  margin-top: 0;\n}\r\n";
styleInject(css_248z$d);

script$m.render = render$m;

var script$l = defineComponent({
  name: 'formField',
  props: {
    label: {
      type: String,
      required: true
    },
    name: String,
    fvDecorate: String,
    required: Boolean,
    validationFn: Function,
    maxLength: Number,
    noValidate: Boolean,
    minValue: Number,
    maxValue: Number,
    // Use in case validated model is different from input value
    validationModel: {
      type: [String, Boolean, Number, Object],
      required: false,
      default: undefined
    }
  },
  computed: {
    _name: function _name() {
      return this.name || utils.camelize(this.label);
    }
  }
});

var _hoisted_1$e = {
  class: "field"
};
var _hoisted_2$d = {
  class: "control is-expanded"
};
function render$l(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_field_validate = resolveComponent("field-validate");

  return openBlock(), createBlock("div", _hoisted_1$e, [createVNode("label", {
    class: ["label", {
      'is-required': _ctx.required
    }],
    for: _ctx._name
  }, toDisplayString(_ctx.label), 11, ["for"]), createVNode("div", _hoisted_2$d, [renderSlot(_ctx.$slots, "default"), !_ctx.noValidate ? (openBlock(), createBlock(_component_field_validate, {
    key: 0,
    "validation-model": _ctx.validationModel,
    for: _ctx._name,
    decorate: _ctx.fvDecorate,
    required: _ctx.required,
    "max-length": _ctx.maxLength,
    "min-value": _ctx.minValue,
    "max-value": _ctx.maxValue,
    "validation-fn": _ctx.validationFn
  }, null, 8, ["validation-model", "for", "decorate", "required", "max-length", "min-value", "max-value", "validation-fn"])) : createCommentVNode("", true)])]);
}

script$l.render = render$l;

var script$k = defineComponent({
  name: 'formAutoComplete',
  components: {
    formField: script$l,
    autoComplete: script$r
  },
  props: {
    label: {
      type: String,
      required: true
    },
    name: String,
    required: Boolean,
    maxLength: Number,
    placeholder: {
      type: String,
      required: false
    },
    textField: String,
    valueField: String,
    codeAsValue: Boolean,
    nameAsValue: Boolean,
    queryFn: {
      type: Function,
      required: true
    },
    getFn: {
      type: Function,
      required: false
    },
    modelValue: {
      required: false,
      default: null
    },
    id: String
  },
  computed: {
    _placeholder: function _placeholder() {
      return this.placeholder || this.label;
    },
    _name: function _name() {
      return this.name || utils.camelize(this.label);
    },
    fvDecorate: function fvDecorate() {
      return "".concat(this._name, "Display");
    },
    model: {
      get: function get() {
        return this.modelValue || null;
      },
      set: function set(newVal) {
        this.$emit('update:modelValue', newVal);
      }
    }
  }
});

function render$k(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_auto_complete = resolveComponent("auto-complete");

  var _component_form_field = resolveComponent("form-field");

  return openBlock(), createBlock(_component_form_field, {
    name: _ctx._name,
    label: _ctx.label,
    "fv-decorate": _ctx.fvDecorate,
    required: _ctx.required,
    "max-length": _ctx.maxLength
  }, {
    default: withCtx(function () {
      return [createVNode(_component_auto_complete, {
        name: _ctx._name,
        "query-fn": _ctx.queryFn,
        modelValue: _ctx.model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.model = $event;
        }),
        "get-fn": _ctx.getFn,
        "name-as-value": _ctx.nameAsValue,
        placeholder: _ctx._placeholder,
        id: _ctx.id,
        "text-field": _ctx.textField,
        "value-field": _ctx.valueField,
        "code-as-value": _ctx.codeAsValue,
        onSelected: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.$emit('selected', $event);
        })
      }, null, 8, ["name", "query-fn", "modelValue", "get-fn", "name-as-value", "placeholder", "id", "text-field", "value-field", "code-as-value"])];
    }),
    _: 1
  }, 8, ["name", "label", "fv-decorate", "required", "max-length"]);
}

script$k.render = render$k;

var script$j = defineComponent({
  name: 'formInput',
  components: {
    formField: script$l
  },
  props: {
    label: {
      type: String,
      required: true
    },
    name: String,
    required: Boolean,
    maxLength: {
      type: Number,
      default: 250
    },
    placeholder: String,
    type: {
      type: String,
      default: "text"
    },
    noValidate: Boolean,
    modelValue: null
  },
  computed: {
    _placeholder: function _placeholder() {
      return this.placeholder || this.label;
    },
    _name: function _name() {
      return this.name || utils.camelize(this.label);
    },
    model: {
      get: function get() {
        return this.modelValue;
      },
      set: function set(newVal) {
        this.$emit('update:modelValue', newVal);
      }
    }
  }
});

function render$j(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_form_field = resolveComponent("form-field");

  return openBlock(), createBlock(_component_form_field, {
    name: _ctx.name,
    label: _ctx.label,
    "max-length": _ctx.maxLength,
    required: _ctx.required,
    "no-validate": _ctx.noValidate
  }, {
    default: withCtx(function () {
      return [withDirectives(createVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.model = $event;
        }),
        type: _ctx.type,
        placeholder: _ctx._placeholder,
        name: _ctx._name,
        required: _ctx.required,
        "max-length": _ctx.maxLength
      }, null, 8, ["type", "placeholder", "name", "required", "max-length"]), [[vModelDynamic, _ctx.model]])];
    }),
    _: 1
  }, 8, ["name", "label", "max-length", "required", "no-validate"]);
}

script$j.render = render$j;

var script$i = defineComponent({
  name: 'selectOption',
  components: {
    loading: script$3$1
  },
  props: {
    modelValue: {
      type: [String, Number]
    },
    name: {
      type: String,
      required: true
    },
    populateFn: {
      type: Promise,
      required: true
    },
    useCode: Boolean,
    isRequired: Boolean
  },
  data: function data() {
    return {
      singleOptionName: null,
      loading: true,
      options: [],
      error: null
    };
  },
  computed: {
    selectMessage: function selectMessage() {
      if (this.error) return '... Error ...';
      return this.loading ? 'Please wait. Loading...' : 'Select...';
    },
    singleOption: function singleOption() {
      return this.isRequired && this.options && this.options.length === 1;
    },
    readOnly: function readOnly() {
      return !this.loading && this.isRequired && this.singleOption;
    },
    selected: {
      get: function get() {
        return this.loading ? null : this.modelValue || null;
      },
      set: function set(newVal) {
        this.$emit('update:modelValue', newVal);
      }
    },
    defaultOptionValue: function defaultOptionValue() {
      return this.error ? this.selected : null;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.populate();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  watch: {
    singleOption: function singleOption(newVal) {
      if (!newVal) return;
      this.selected = this.value(this.options[0]);
      this.singleOptionName = this.options[0].name;
    }
  },
  methods: {
    value: function value(option) {
      if (option === null) return null;
      return this.useCode ? option.code : option.id;
    },
    populate: function populate() {
      var that = this;
      return this.populateFn.then(function (response) {
        return that.options = response;
      }).catch(this.handlePopulateError).finally(function () {
        return that.loading = false;
      });
    },
    handlePopulateError: function handlePopulateError(err) {
      this.error = true;
      err.message = "Error getting ".concat(this.name, " list: ").concat(err.message);
      this.$error(err);
    }
  }
});

var _hoisted_1$d = {
  class: "select is-fullwidth"
};
var _hoisted_2$c = {
  key: 0
};
function render$i(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_loading = resolveComponent("loading");

  return openBlock(), createBlock(Fragment, null, [withDirectives(createVNode("div", _hoisted_1$d, [withDirectives(createVNode("select", {
    name: _ctx.name,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.selected = $event;
    }),
    class: "input"
  }, [createVNode("option", {
    value: _ctx.defaultOptionValue
  }, toDisplayString(_ctx.selectMessage), 9, ["value"]), (openBlock(true), createBlock(Fragment, null, renderList(_ctx.options, function (x) {
    return openBlock(), createBlock("option", {
      value: _ctx.value(x),
      key: _ctx.value(x)
    }, toDisplayString(x.name), 9, ["value"]);
  }), 128))], 8, ["name"]), [[vModelSelect, _ctx.selected]]), _ctx.loading ? (openBlock(), createBlock(_component_loading, {
    key: 0
  })) : createCommentVNode("", true)], 512), [[vShow, !_ctx.readOnly]]), _ctx.readOnly ? (openBlock(), createBlock("span", _hoisted_2$c, toDisplayString(_ctx.singleOptionName), 1)) : createCommentVNode("", true)], 64);
}

script$i.render = render$i;

var script$h = defineComponent({
  name: 'formSelect',
  components: {
    formField: script$l,
    selectOption: script$i
  },
  props: {
    modelValue: null,
    label: {
      type: String,
      required: true
    },
    name: String,
    required: Boolean,
    populateFn: {
      type: Promise,
      required: true
    },
    useCode: Boolean
  },
  computed: {
    _name: function _name() {
      return this.name || utils.camelize(this.label);
    },
    model: {
      get: function get() {
        return this.modelValue || null;
      },
      set: function set(newVal) {
        this.$emit('update:modelValue', newVal);
      }
    }
  }
});

function render$h(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_select_option = resolveComponent("select-option");

  var _component_form_field = resolveComponent("form-field");

  return openBlock(), createBlock(_component_form_field, {
    name: _ctx._name,
    label: _ctx.label,
    required: _ctx.required
  }, {
    default: withCtx(function () {
      return [createVNode(_component_select_option, {
        modelValue: _ctx.model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.model = $event;
        }),
        name: _ctx._name,
        "populate-fn": _ctx.populateFn,
        "use-code": _ctx.useCode,
        "is-required": _ctx.required
      }, null, 8, ["modelValue", "name", "populate-fn", "use-code", "is-required"])];
    }),
    _: 1
  }, 8, ["name", "label", "required"]);
}

script$h.render = render$h;

var script$g = defineComponent({
  name: 'formText',
  components: {
    formField: script$l
  },
  props: {
    label: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
});

function render$g(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_form_field = resolveComponent("form-field");

  return openBlock(), createBlock(_component_form_field, {
    label: _ctx.label,
    "no-validate": ""
  }, {
    default: withCtx(function () {
      return [createVNode("span", null, toDisplayString(_ctx.text), 1)];
    }),
    _: 1
  }, 8, ["label"]);
}

script$g.render = render$g;

var DEFAULT_CURENCY = 'usd';
var script$f = defineComponent({
  name: 'selectCurrency',
  props: {
    modelValue: String
  },
  data: function data() {
    var selected = this.modelValue || DEFAULT_CURENCY;
    return {
      value: selected
    };
  },
  watch: {
    value: function value(newVal) {
      this.$emit('update:modelValue', newVal);
    }
  }
});

var _withId$6 = /*#__PURE__*/withScopeId("data-v-c6aa057a");

pushScopeId("data-v-c6aa057a");

var _hoisted_1$c = {
  class: "select"
};

var _hoisted_2$b = /*#__PURE__*/createVNode("option", {
  value: "eur"
}, "€", -1);

var _hoisted_3$9 = /*#__PURE__*/createVNode("option", {
  value: "gbp"
}, "£", -1);

var _hoisted_4$6 = /*#__PURE__*/createVNode("option", {
  value: "jpy"
}, "¥", -1);

var _hoisted_5$5 = /*#__PURE__*/createVNode("option", {
  value: "usd"
}, "$", -1);

popScopeId();

var render$f = /*#__PURE__*/_withId$6(function (_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("span", _hoisted_1$c, [withDirectives(createVNode("select", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.value = $event;
    })
  }, [_hoisted_2$b, _hoisted_3$9, _hoisted_4$6, _hoisted_5$5], 512), [[vModelSelect, _ctx.value]])]);
});

var css_248z$c = "\nselect[data-v-c6aa057a] {\r\n  font-weight: bold;\n}\r\n";
styleInject(css_248z$c);

script$f.render = render$f;
script$f.__scopeId = "data-v-c6aa057a";

var script$e = defineComponent({
  name: 'qtyInput',
  props: {
    modelValue: [Number, String]
  },
  data: function data() {
    return {
      model: this.modelValue
    };
  },
  computed: {
    modelText: function modelText() {
      return (this.model || '').toLocaleString();
    }
  },
  watch: {
    modelValue: function modelValue(newVal) {
      this.model = newVal;
    },
    model: function model(newVal) {
      this.$emit('update:modelValue', newVal);
    }
  },
  methods: {
    onInput: debounce(function (e) {
      var val = this.replaceMultiplier(e.target.value);
      this.model = val;
    }, 250),
    replaceMultiplier: function replaceMultiplier(inputText) {
      var found = inputText.match(/^([0-9,.]*)([km])$/i);
      if (!found) return inputText;
      var val = found[1];
      var multiplier = found[2].toLowerCase();
      if (multiplier == 'k') return val * 1000;else if (multiplier == 'm') return val * 1000000;else return inputText;
    }
  }
});

function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("input", {
    type: "text",
    value: _ctx.modelText,
    onInput: _cache[1] || (_cache[1] = function () {
      return _ctx.onInput && _ctx.onInput.apply(_ctx, arguments);
    })
  }, null, 40, ["value"]);
}

script$e.render = render$e;

var script$d = defineComponent({
  name: "discardChangesDialog",
  components: {
    modalCard: script$4$1
  },
  emits: ["done"],
  props: {
    isVisible: Boolean
  },
  methods: {
    done: function done(proceed) {
      this.$emit("done", proceed);
    }
  }
});

var _hoisted_1$b = /*#__PURE__*/createTextVNode("Discard changes?");

var _hoisted_2$a = /*#__PURE__*/createVNode("div", null, "All your changes will be lost.", -1);

var _hoisted_3$8 = {
  class: "buttons"
};
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_modal_card = resolveComponent("modal-card");

  return openBlock(), createBlock(_component_modal_card, {
    active: _ctx.isVisible
  }, {
    title: withCtx(function () {
      return [_hoisted_1$b];
    }),
    body: withCtx(function () {
      return [_hoisted_2$a];
    }),
    foot: withCtx(function () {
      return [createVNode("div", _hoisted_3$8, [createVNode("button", {
        type: "button",
        class: "is-danger is-light",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _ctx.done(true);
        })
      }, "Discard"), createVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return _ctx.done(false);
        })
      }, "Keep editing")])];
    }),
    _: 1
  }, 8, ["active"]);
}

var css_248z$b = "\r\n\r\n";
styleInject(css_248z$b);

script$d.render = render$d;

var script$c = defineComponent({
  name: "dirtyTracker",
  components: {
    discardChangesDialog: script$d
  },
  props: {
    tracked: Object
  },
  data: function data() {
    return {
      original: {},
      showDialog: false,
      next: null,
      removeGuard: null
    };
  },
  mounted: function mounted() {
    // Make a snapshot of the tracked model
    this.original = this.unwrap(this.tracked); // Add listeners

    window.addEventListener("beforeunload", this.showWarningOnDirty);
    this.removeGuard = this.$router.beforeEach(this.routeGuard);
  },
  methods: {
    routeGuard: function routeGuard(to, from, next) {
      if (!this.isDirty()) {
        next();
        return;
      }

      this.next = next;
      this.showDialog = true;
    },
    showWarningOnDirty: function showWarningOnDirty(event) {
      if (!this.isDirty()) return; // Cancel the unload event
      // Preventing default behavior will trigger the prompt in firefox

      event.preventDefault(); // Chrome requires returnValue to be set

      event.returnValue = "";
    },
    unwrap: function unwrap(object) {
      return Object.assign({}, object);
    },
    resolveDiscardChangesDialog: function resolveDiscardChangesDialog(event) {
      var _this = this;

      if (event && this.next) {
        this.showDialog = false;
        this.$closeModal(function () {
          return _this.next();
        });
      } else {
        this.showDialog = false;
      }
    },

    /** Needs to be a method 
     * - computed prop is not updated correctly if only used in callbacks 
     */
    isDirty: function isDirty() {
      // isEqual is comparing constructors if all own properties are equal 
      // so we need to unwrap tracked model as done for the snapshot
      var current = this.unwrap(this.tracked);
      return !isEqual(this.original, current);
    }
  },
  unmounted: function unmounted() {
    this.removeGuard();
    window.removeEventListener("beforeunload", this.showWarningOnDirty);
  }
});

function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_discard_changes_dialog = resolveComponent("discard-changes-dialog");

  return openBlock(), createBlock(_component_discard_changes_dialog, {
    isVisible: _ctx.showDialog,
    onDone: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.resolveDiscardChangesDialog($event);
    })
  }, null, 8, ["isVisible"]);
}

var css_248z$a = "\r\n";
styleInject(css_248z$a);

script$c.render = render$c;

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  autoComplete: script$r,
  fileUpload: script$m,
  formAutoComplete: script$k,
  formField: script$l,
  formInput: script$j,
  formSelect: script$h,
  formText: script$g,
  selectCurrency: script$f,
  selectOption: script$i,
  qtyInput: script$e,
  dirtyTracker: script$c,
  discardChangesDialog: script$d
});

var script$b = defineComponent({
  name: "accountMenu",
  data: function data() {
    return {
      isActive: false
    };
  },
  computed: _objectSpread2$1({}, mapState("auth", ["name", "userName"])),
  methods: {
    toggleActive: function toggleActive() {
      this.isActive ? this.deactivate() : this.activate();
    },
    activate: function activate() {
      this.isActive = true;
      vm$1 = this;
      window.addEventListener("click", clickListener$1);
    },
    deactivate: function deactivate() {
      this.isActive = false;
      window.removeEventListener("click", clickListener$1);
    }
  }
});
var vm$1;

var clickListener$1 = function clickListener(e) {
  var menu = document.querySelector("#avatarMenu");
  if (!menu) return;
  if (!menu.contains(e.target)) vm$1.deactivate();
};

var _withId$5 = /*#__PURE__*/withScopeId("data-v-26f50dbe");

pushScopeId("data-v-26f50dbe");

var _hoisted_1$a = {
  class: "accountInfo"
};
var _hoisted_2$9 = {
  class: "ellipsed is-lowercase is-size-7"
};

var _hoisted_3$7 = /*#__PURE__*/createVNode("span", {
  class: "icon"
}, [/*#__PURE__*/createVNode("i", {
  class: "far fa-user-circle fa-lg"
})], -1);

var _hoisted_4$5 = {
  class: "navbar-dropdown"
};

var _hoisted_5$4 = /*#__PURE__*/createVNode("div", {
  class: "logout-item"
}, [/*#__PURE__*/createVNode("span", {
  class: "mr-2"
}, [/*#__PURE__*/createVNode("i", {
  class: "fas fa-sign-out-alt fa-fw"
})]), /*#__PURE__*/createTextVNode(" Logout ")], -1);

popScopeId();

var render$b = /*#__PURE__*/_withId$5(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = resolveComponent("router-link");

  return openBlock(), createBlock("div", {
    id: "account-menu",
    class: ["navbar-item has-dropdown", {
      'is-active': _ctx.isActive
    }]
  }, [createVNode("div", {
    class: "navbar-link is-arrowless",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.toggleActive && _ctx.toggleActive.apply(_ctx, arguments);
    })
  }, [createVNode("div", _hoisted_1$a, [createVNode("div", null, toDisplayString(_ctx.name), 1), createVNode("div", _hoisted_2$9, toDisplayString(_ctx.userName), 1)]), _hoisted_3$7]), createVNode("div", _hoisted_4$5, [createVNode(_component_router_link, {
    class: "dropdown-item link-item",
    to: {
      name: 'Logout'
    }
  }, {
    default: _withId$5(function () {
      return [_hoisted_5$4];
    }),
    _: 1
  })])], 2);
});

var css_248z$9 = "\n.ellipsed[data-v-26f50dbe] {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    display: block;\r\n    text-overflow: ellipsis;\n}\n.navbar-link[data-v-26f50dbe] {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding-left: 0.25em;\r\n    padding-right: 0.75em;\n}\n.accountInfo[data-v-26f50dbe] {\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-align: right;\r\n    margin-right: 0.25em;\n}\n.navbar-dropdown[data-v-26f50dbe] {\r\n    font-size: inherit;\n}\n.dropdown-item[data-v-26f50dbe] {\r\n    text-align: left;\n}\n.logout-item[data-v-26f50dbe] {\r\n    padding: 0.5rem 0;\n}\n@media screen and (max-width: 1023px) {\n.navbar-link.is-arrowless[data-v-26f50dbe] {\r\n      display: none;\n}\n.dropdown-item[data-v-26f50dbe] {\r\n      padding: 0;\n}\n.navbar-dropdown[data-v-26f50dbe] {\r\n      padding: 0;\n}\n}\n@media screen and (min-width: 1024px) {\n.is-small-screen[data-v-26f50dbe] {\r\n      display: none;\n}\n}\n.link-item[data-v-26f50dbe] {\r\n    color: #4a4a4a;\n}\n.link-item[data-v-26f50dbe]:hover {\r\n    background-color: #fafafa;\r\n    color: #3273dc;\n}\r\n";
styleInject(css_248z$9);

script$b.render = render$b;
script$b.__scopeId = "data-v-26f50dbe";

var script$a = defineComponent({
  name: "navbarItems",
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  methods: {
    isActiveLink: function isActiveLink(url, subItems) {
      var _this = this;

      if (this.$route.path === url) {
        return true;
      }

      if (subItems && subItems.length) {
        return subItems.some(function (item) {
          return _this.$route.path === item.url;
        });
      }
    },
    hasChildren: function hasChildren(menuItem) {
      return menuItem.children && menuItem.children.length;
    }
  }
});

var _withId$4 = /*#__PURE__*/withScopeId("data-v-3fbf0e09");

pushScopeId("data-v-3fbf0e09");

var _hoisted_1$9 = {
  style: {
    "display": "inherit"
  }
};
var _hoisted_2$8 = {
  class: "mr-2"
};
var _hoisted_3$6 = {
  key: 0,
  class: "navbar-dropdown"
};
var _hoisted_4$4 = {
  class: "mr-2"
};

popScopeId();

var render$a = /*#__PURE__*/_withId$4(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = resolveComponent("router-link");

  return openBlock(), createBlock("div", _hoisted_1$9, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.menuItems, function (item, i) {
    return openBlock(), createBlock("div", {
      key: i,
      class: ["navbar-item", {
        'is-hoverable has-dropdown': _ctx.hasChildren(item),
        'is-active-link': _ctx.isActiveLink(item.url, item.children)
      }]
    }, [createVNode(_component_router_link, {
      to: item.url,
      class: ["link-full-height", {
        'navbar-link': _ctx.hasChildren(item)
      }]
    }, {
      default: _withId$4(function () {
        return [createVNode("span", _hoisted_2$8, [createVNode("i", {
          class: [item.icon, "fa-fw"]
        }, null, 2)]), createTextVNode(toDisplayString(item.title), 1)];
      }),
      _: 2
    }, 1032, ["to", "class"]), _ctx.hasChildren(item) ? (openBlock(), createBlock("div", _hoisted_3$6, [(openBlock(true), createBlock(Fragment, null, renderList(item.children, function (subitem, j) {
      return openBlock(), createBlock(_component_router_link, {
        key: j,
        class: ["navbar-item", {
          'is-active-link': _ctx.isActiveLink(subitem.url)
        }],
        to: subitem.url
      }, {
        default: _withId$4(function () {
          return [createVNode("span", _hoisted_4$4, [createVNode("i", {
            class: [subitem.icon, "fa-fw"]
          }, null, 2)]), createTextVNode(toDisplayString(subitem.title), 1)];
        }),
        _: 2
      }, 1032, ["to", "class"]);
    }), 128))])) : createCommentVNode("", true)], 2);
  }), 128))]);
});

var css_248z$8 = "\n.navbar-item > a[data-v-3fbf0e09]:hover,\r\n.navbar-item:hover > a[data-v-3fbf0e09],\r\n.navbar-item[data-v-3fbf0e09]:hover {\r\n  background-color: #fafafa;\r\n  color: #3273dc !important;\n}\n.is-active-link[data-v-3fbf0e09],\r\n.is-active-link > a[data-v-3fbf0e09],\r\n.is-active-link > a[data-v-3fbf0e09]:after {\r\n  color: #3273dc !important;\n}\n.is-active-link > a[data-v-3fbf0e09]:after {\r\n  border-color: #3273dc !important;\n}\n.navbar-item > a[data-v-3fbf0e09] {\r\n  color: #4a4a4a;\n}\n@media screen and (max-width: 1023px) {\n.navbar-item[data-v-3fbf0e09] {\r\n    font-size: 0.875rem;\n}\n}\n@media  screen and (min-width: 1024px) {\n.navbar-dropdown a.navbar-item[data-v-3fbf0e09] {\r\n    padding-right: 0;\n}\n}\n.link-full-height[data-v-3fbf0e09] {\r\n  display: flex;\r\n  align-items: center;\r\n  height: 100%;\n}\n.navbar-link[data-v-3fbf0e09]:not(.is-arrowless)::after {\r\n    border-color: #4a4a4a;\n}\r\n\r\n";
styleInject(css_248z$8);

script$a.render = render$a;
script$a.__scopeId = "data-v-3fbf0e09";

var NavbarMenuItem = function NavbarMenuItem(title, url, icon) {
  var children = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  _classCallCheck(this, NavbarMenuItem);

  this.title = title;
  this.url = url;
  this.icon = icon; // subMenu items

  if (Array.isArray(children) && children.length) {
    this.children = children;
  } else {
    this.children = [];
  }
};

var script$9 = defineComponent({
  name: 'ebiz-apps-item',
  props: {
    title: String,
    icon: String,
    label: String,
    href: String
  },
  computed: {
    iconClass: function iconClass() {
      return "fas fa-2x fa-".concat(this.icon);
    }
  }
});

var _withId$3 = /*#__PURE__*/withScopeId("data-v-19d74d4f");

pushScopeId("data-v-19d74d4f");

var _hoisted_1$8 = {
  class: ".ebiz-menu-item"
};
var _hoisted_2$7 = {
  class: "icon is-large"
};

popScopeId();

var render$9 = /*#__PURE__*/_withId$3(function (_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("div", _hoisted_1$8, [createVNode("a", {
    href: _ctx.href,
    title: _ctx.title,
    class: "ebiz-menu-item"
  }, [createVNode("span", _hoisted_2$7, [createVNode("i", {
    class: _ctx.iconClass
  }, null, 2)]), createVNode("span", null, toDisplayString(_ctx.label), 1)], 8, ["href", "title"])]);
});

var css_248z$7 = "\n.ebiz-menu-item[data-v-19d74d4f] {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\n}\r\n";
styleInject(css_248z$7);

script$9.render = render$9;
script$9.__scopeId = "data-v-19d74d4f";

/* https://stackoverflow.com/a/60147946 */
var clickOutside = {
  created: function created(element, binding) {
    element.clickOutsideEvent = function (event) {
      // check that click was outside the el and its children
      if (!(element === event.target || element.contains(event.target))) {
        // optional directive argument in form of a reference to activator element can be supplied. 
        // if it's supplied, then additional check is performed if event target is not activator element. 
        // invoking click on activator element should not call biding.value() function. 
        if ((binding === null || binding === void 0 ? void 0 : binding.arg) instanceof Element && binding !== null && binding !== void 0 && binding.arg.contains(event.target)) {
          return;
        } // call method provided in attribute value


        binding.value(event);
      }
    }; // adding event listener on window, since we might have pages where document is small
    // and clicking outside of document, but inside the page is not triggered (e.g. error page)


    window.addEventListener('click', element.clickOutsideEvent);
  },
  beforeUnmount: function beforeUnmount(element) {
    window.removeEventListener('click', element.clickOutsideEvent);
  }
};

var script$8 = defineComponent({
  name: 'ebiz-apps-menu',
  components: {
    menuItem: script$9
  },
  directives: {
    clickOutside: clickOutside
  },
  data: function data() {
    return {
      showMenu: false,
      apps: []
    };
  },
  methods: _objectSpread2$1(_objectSpread2$1({}, ebizApps), {}, {
    toggleMenu: function toggleMenu(e) {
      this.showMenu = !this.showMenu;
    }
  }),
  mounted: function mounted() {
    this.apps = this.getUserApps();
  }
});

var _withId$2 = /*#__PURE__*/withScopeId("data-v-dd74b272");

pushScopeId("data-v-dd74b272");

var _hoisted_1$7 = /*#__PURE__*/createVNode("span", {
  class: "icon",
  title: "eBiz Applications Menu"
}, [/*#__PURE__*/createVNode("i", {
  class: "fas fa-th"
})], -1);

var _hoisted_2$6 = {
  key: 0,
  class: "ebiz-menu-container box"
};
var _hoisted_3$5 = {
  class: "columns is-multiline is-centered are-half"
};

popScopeId();

var render$8 = /*#__PURE__*/_withId$2(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_menu_item = resolveComponent("menu-item");

  var _directive_click_outside = resolveDirective("click-outside");

  return openBlock(), createBlock("div", null, [createVNode("button", {
    ref: "globalMenuActivator",
    type: "button",
    class: ["button", {
      'is-link is-inverted is-hovered': _ctx.showMenu
    }],
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.toggleMenu && _ctx.toggleMenu.apply(_ctx, arguments);
    })
  }, [_hoisted_1$7], 2), createVNode(Transition, {
    name: "menu-box-expand"
  }, {
    default: _withId$2(function () {
      return [_ctx.showMenu ? withDirectives((openBlock(), createBlock("div", _hoisted_2$6, [createVNode("div", _hoisted_3$5, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.apps, function (app, index) {
        return openBlock(), createBlock(_component_menu_item, {
          key: index,
          title: app.title,
          label: app.label,
          icon: app.icon,
          href: app.href
        }, null, 8, ["title", "label", "icon", "href"]);
      }), 128))])], 512)), [[_directive_click_outside, _ctx.toggleMenu, _ctx.$refs.globalMenuActivator]]) : createCommentVNode("", true)];
    }),
    _: 1
  })]);
});

var css_248z$6 = "\n.ebiz-menu-container[data-v-dd74b272] {\r\n  position: fixed;\r\n  top: 10vh;\r\n  right: 1vw;\r\n  padding: 15px;\r\n  border-radius: 5px;\r\n  width: 300px;\n}\n.menu-box-expand-enter-from[data-v-dd74b272],\r\n.menu-box-expand-leave-to[data-v-dd74b272] {\r\n  opacity: 0;\n}\n.menu-box-expand-enter-active[data-v-dd74b272],\r\n.menu-box-expand-leave-active[data-v-dd74b272] {\r\n  transition: all 0.35s ease-in-out;\n}\r\n";
styleInject(css_248z$6);

script$8.render = render$8;
script$8.__scopeId = "data-v-dd74b272";

var script$7 = defineComponent({
  name: "navbar",
  components: {
    accountMenu: script$b,
    navbarItems: script$a,
    ebizAppsMenu: script$8
  },
  props: {
    menuItems: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      burgerMenuActive: false,
      portalUrl: process.env.VUE_APP_PORTAL_URL || '/'
    };
  },
  methods: {
    toggleBurgerMenu: function toggleBurgerMenu() {
      this.burgerMenuActive ? this.deactivateBurgerMenu() : this.activateBurgerMenu();
    },
    activateBurgerMenu: function activateBurgerMenu() {
      this.burgerMenuActive = true;
      vm = this;
      window.addEventListener('click', clickListener);
    },
    deactivateBurgerMenu: function deactivateBurgerMenu() {
      this.burgerMenuActive = false;
      window.removeEventListener('click', clickListener);
    }
  }
});
var vm;

var clickListener = function clickListener(e) {
  if (!document.querySelector(".navbar").contains(e.target)) vm.deactivateBurgerMenu();
};

var _hoisted_1$6 = {
  class: "navbar"
};
var _hoisted_2$5 = {
  class: "navbar-brand"
};

var _hoisted_3$4 = /*#__PURE__*/createVNode("img", {
  src: "https://cdn.allegromicro.com/logos/aml_50h.png"
}, null, -1);

var _hoisted_4$3 = {
  class: "navbar-item search-box-small-screen"
};
var _hoisted_5$3 = {
  class: "navbar-item is-hidden-desktop"
};

var _hoisted_6$3 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_7$3 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_8$3 = /*#__PURE__*/createVNode("span", null, null, -1);

var _hoisted_9$3 = {
  class: "navbar-start"
};
var _hoisted_10$1 = {
  class: "navbar-end"
};
var _hoisted_11$1 = {
  class: "navbar-item search-box-wide-screen"
};
var _hoisted_12$1 = {
  class: "navbar-item is-hidden-mobile is-hidden-tablet-only"
};
var _hoisted_13$1 = {
  class: "navbar-item"
};
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ebiz_apps_menu = resolveComponent("ebiz-apps-menu");

  var _component_navbar_items = resolveComponent("navbar-items");

  var _component_account_menu = resolveComponent("account-menu");

  return openBlock(), createBlock("nav", _hoisted_1$6, [createVNode("div", _hoisted_2$5, [createVNode("a", {
    id: "navbarLogo",
    class: "navbar-item",
    href: _ctx.portalUrl
  }, [_hoisted_3$4], 8, ["href"]), createVNode("div", _hoisted_4$3, [renderSlot(_ctx.$slots, "searchBox")]), createVNode("div", _hoisted_5$3, [createVNode(_component_ebiz_apps_menu)]), createVNode("a", {
    role: "button",
    class: ["navbar-burger", {
      'is-active': _ctx.burgerMenuActive
    }],
    "data-target": "navbarMenu",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.toggleBurgerMenu && _ctx.toggleBurgerMenu.apply(_ctx, arguments);
    })
  }, [_hoisted_6$3, _hoisted_7$3, _hoisted_8$3], 2)]), createVNode("div", {
    id: "navbarMenu",
    class: ["navbar-menu", {
      'is-active': _ctx.burgerMenuActive
    }]
  }, [createVNode("div", _hoisted_9$3, [createVNode(_component_navbar_items, {
    menuItems: _ctx.menuItems
  }, null, 8, ["menuItems"])]), createVNode("div", _hoisted_10$1, [createVNode("div", _hoisted_11$1, [renderSlot(_ctx.$slots, "searchBox")]), createVNode("div", _hoisted_12$1, [createVNode(_component_ebiz_apps_menu)]), createVNode("div", _hoisted_13$1, [createVNode(_component_account_menu)])])], 2)]);
}

var css_248z$5 = "\n.navbar-brand {\r\n  margin-left: 1em;\n}\n.navbar {\r\n  border-bottom: 1px solid #ebebeb;\n}\n@media screen and (max-width: 1023px) {\n.search-box-wide-screen {\r\n    display: none;\n}\n}\n@media screen and (min-width: 1024px) {\n.search-box-small-screen {\r\n    display: none;\n}\n}\n.navbar-item button {\r\n  border: none;\r\n  background-color: inherit;\r\n  transition: all 1s;\n}\n.navbar-item button:focus {\r\n  box-shadow: none !important;\n}\n.navbar-item button:hover {\r\n  background-color: #efefef;\r\n  transition: all 2s;\n}\r\n\r\n/* To make sure that in mobile view, icons are right-sided */\n.navbar-burger {\r\n  margin-left: inherit;\n}\r\n\r\n/* To make sure that in mobile view, icons are right-sided and search is the most left sided icon on navbar.*/\n.search-box-small-screen {\r\n  margin-left: auto;\n}\r\n";
styleInject(css_248z$5);

script$7.render = render$7;

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  accountMenu: script$b,
  navbar: script$7,
  navbarItems: script$a,
  NavbarMenuItem: NavbarMenuItem,
  ebizAppsItem: script$9
});

var script$6 = defineComponent({
  name: "decisionDialog",
  components: {
    modalDialog: script$5$1,
    modalCard: script$4$1
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    outcomes: {
      /** outcome object must have id, label and optional requiresComment props */
      type: Array,
      required: true
    },
    outcomeIdPropName: {
      /** override name of outcome property of "id" if needed */
      type: String,
      required: false,
      default: "id"
    },
    outcomeLabelPropName: {
      /** override name of outcome property of "label" if needed */
      type: String,
      required: false,
      default: "label"
    },
    maxCommentsLength: {
      type: Number,
      required: false,
      default: 2000
    }
  },
  emit: ["resolveDialogAction"],
  data: function data() {
    return {
      selectedOutcome: null,
      comments: "",
      commentsError: "",
      decisionError: "",
      formId: "decisionDialogForm"
    };
  },
  computed: {
    outcomeRequiresComment: function outcomeRequiresComment() {
      var _this$selectedOutcome;

      return !!((_this$selectedOutcome = this.selectedOutcome) !== null && _this$selectedOutcome !== void 0 && _this$selectedOutcome.requiresComment);
    },
    decision: function decision() {
      return this.selectedOutcome ? {
        outcomeId: this.selectedOutcomeId,
        comments: this.comments
      } : null;
    },
    selectedOutcomeId: function selectedOutcomeId() {
      return this.selectedOutcome ? this.selectedOutcome[this.outcomeIdPropName] : null;
    }
  },
  methods: {
    selectOutcome: function selectOutcome(outcome) {
      this.selectedOutcome = outcome;
    },
    decisionButtonClass: function decisionButtonClass(id) {
      if (!this.decision) return null;
      var isSelected = this.decision.outcomeId === id;
      return {
        "is-primary": isSelected,
        "is-light": !isSelected
      };
    },
    isDecisionValid: function isDecisionValid() {
      if (!this.decision) {
        this.decisionError = "Decision is required.";
        return false;
      }

      this.decisionError = "";
      return true;
    },
    isFormValid: function isFormValid() {
      return this.isDecisionValid() && this.areFieldsValid();
    },
    areFieldsValid: function areFieldsValid() {
      var fieldErrors = this.$validate(this.formId);
      return !fieldErrors.length;
    },
    resolveDialogAction: function resolveDialogAction(proceed) {
      if (!proceed) {
        this.$emit("resolveDialogAction", null);
        return;
      }

      if (!this.isFormValid()) return;
      this.$emit("resolveDialogAction", this.decision);
    }
  },
  watch: {
    decision: function decision() {
      this.isDecisionValid();
    }
  }
});

var _withId$1 = /*#__PURE__*/withScopeId("data-v-7882183c");

pushScopeId("data-v-7882183c");

var _hoisted_1$5 = /*#__PURE__*/createVNode("h4", null, "Choose decision", -1);

var _hoisted_2$4 = {
  class: "field is-horizontal"
};

var _hoisted_3$3 = /*#__PURE__*/createVNode("span", {
  class: "mr-0"
}, "Please select your decision:", -1);

var _hoisted_4$2 = {
  class: "field-body"
};
var _hoisted_5$2 = {
  class: "buttons has-addons"
};
var _hoisted_6$2 = {
  key: 0,
  class: "help is-danger"
};
var _hoisted_7$2 = {
  class: "field"
};

var _hoisted_8$2 = /*#__PURE__*/createVNode("label", {
  for: "decisionComments"
}, " Decision Comment ", -1);

var _hoisted_9$2 = {
  key: 0,
  class: "help is-danger"
};

popScopeId();

var render$6 = /*#__PURE__*/_withId$1(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_field_validate = resolveComponent("field-validate");

  var _component_modal_dialog = resolveComponent("modal-dialog");

  return openBlock(), createBlock(_component_modal_dialog, {
    active: _ctx.active,
    "is-save": true,
    onDone: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.resolveDialogAction($event);
    })
  }, {
    title: _withId$1(function () {
      return [renderSlot(_ctx.$slots, "title", {}, function () {
        return [_hoisted_1$5];
      })];
    }),
    body: _withId$1(function () {
      var _ctx$selectedOutcome;

      return [renderSlot(_ctx.$slots, "subtitle"), createVNode("form", {
        id: _ctx.formId
      }, [createVNode("div", _hoisted_2$4, [_hoisted_3$3, createVNode("div", _hoisted_4$2, [createVNode("div", _hoisted_5$2, [(openBlock(true), createBlock(Fragment, null, renderList(_ctx.outcomes, function (outcome) {
        return openBlock(), createBlock("button", {
          type: "button",
          key: outcome[_ctx.outcomeIdPropName],
          class: [_ctx.decisionButtonClass(outcome[_ctx.outcomeIdPropName]), "outcome-button"],
          onClick: function onClick($event) {
            return _ctx.selectOutcome(outcome);
          }
        }, toDisplayString(outcome[_ctx.outcomeLabelPropName]), 11, ["onClick"]);
      }), 128))]), _ctx.decisionError ? (openBlock(), createBlock("p", _hoisted_6$2, toDisplayString(_ctx.decisionError), 1)) : createCommentVNode("", true)])]), createVNode("div", _hoisted_7$2, [_hoisted_8$2, _ctx.outcomeRequiresComment ? (openBlock(), createBlock("span", _hoisted_9$2, "(required)")) : createCommentVNode("", true), withDirectives(createVNode("textarea", {
        placeholder: "Decision comment",
        name: "decisionComments",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.comments = $event;
        })
      }, null, 512), [[vModelText, _ctx.comments]]), createVNode(_component_field_validate, {
        for: "decisionComments",
        required: (_ctx$selectedOutcome = _ctx.selectedOutcome) === null || _ctx$selectedOutcome === void 0 ? void 0 : _ctx$selectedOutcome.requiresComment,
        "max-length": _ctx.maxCommentsLength
      }, null, 8, ["required", "max-length"])])], 8, ["id"])];
    }),
    _: 3
  }, 8, ["active"]);
});

var css_248z$4 = "\n.field.is-horizontal > .field-body[data-v-7882183c] {\r\n  display: block;\n}\n.field-body > .buttons[data-v-7882183c] {\r\n  margin-bottom: 0;\n}\n.field-body > .buttons > .button[data-v-7882183c] {\r\n  margin-bottom: 0;\n}\nspan.help.is-danger[data-v-7882183c] {\r\n  font-size: 0.75rem;\n}\r\n\r\n/** Override for Bulma buttons styles because of nested component inside buttons div */\n.buttons.is-right button.outcome-button[data-v-7882183c] {\r\n  margin-left: 0;\r\n  margin-right: -1px;\n}\n#decisionDialogForm[data-v-7882183c] {\r\n  color: initial;\n}\r\n";
styleInject(css_248z$4);

script$6.render = render$6;
script$6.__scopeId = "data-v-7882183c";

var script$5 = defineComponent({
  name: "reviewManager",
  components: {
    decisionDialog: script$6
  },
  emits: ["reviewDone"],
  props: {
    fullName: {
      type: String,
      required: false,
      default: "Review"
    },
    outcomes: {
      /** outcome object must have id, label and optional requiresComment props */
      type: Array,
      required: true
    },
    outcomeIdPropName: {
      /** override name of outcome property of "id" if needed */
      type: String,
      required: false
    },
    outcomeLabelPropName: {
      /** override name of outcome property of "label" if needed */
      type: String,
      required: false
    },
    maxCommentsLength: {
      type: Number,
      required: false,
      default: 2000
    }
  },
  data: function data() {
    return {
      isDialogVisible: false
    };
  },
  methods: {
    openDialog: function openDialog() {
      this.isDialogVisible = true;
    },
    resolveDialogAction: function resolveDialogAction(decision) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isDialogVisible = false;

                _this.$closeModal(function () {
                  if (decision) _this.$emit("reviewDone", decision);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
});

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_decision_dialog = resolveComponent("decision-dialog");

  return openBlock(), createBlock(Fragment, null, [_ctx.outcomes.length ? renderSlot(_ctx.$slots, "dialog-activator", {
    key: 0,
    openDialog: _ctx.openDialog
  }) : createCommentVNode("", true), createVNode(_component_decision_dialog, {
    active: _ctx.isDialogVisible,
    outcomes: _ctx.outcomes,
    outcomeIdPropName: _ctx.outcomeIdPropName,
    maxCommentsLength: _ctx.maxCommentsLength,
    onResolveDialogAction: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.resolveDialogAction($event);
    })
  }, {
    title: withCtx(function () {
      return [createVNode("h4", null, toDisplayString(_ctx.fullName), 1)];
    }),
    subtitle: withCtx(function () {
      return [renderSlot(_ctx.$slots, "dialog-subtitle")];
    }),
    _: 3
  }, 8, ["active", "outcomes", "outcomeIdPropName", "maxCommentsLength"])], 64);
}

script$5.render = render$5;

var script$4 = defineComponent({
  name: "toggleButton",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    classOn: {
      type: String
    },
    classOff: {
      type: String
    },
    classAlways: {
      type: String
    },
    iconOn: {
      type: String
    },
    iconOff: {
      type: String
    },
    titleOn: {
      type: String
    },
    titleOff: {
      type: String
    }
  },
  computed: {
    hasLabel: function hasLabel() {
      return !!(this.modelValue && this.titleOn || !this.modelValue && this.titleOff);
    }
  }
});

var _hoisted_1$4 = {
  key: 0,
  class: "icon"
};
var _hoisted_2$3 = {
  key: 1,
  class: "icon"
};
var _hoisted_3$2 = {
  key: 2
};
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("span", {
    class: ["button", [_ctx.modelValue ? _ctx.classOn : _ctx.classOff, _ctx.classAlways]],
    title: _ctx.modelValue ? _ctx.titleOn : _ctx.titleOff,
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('update:modelValue', !_ctx.modelValue);
    })
  }, [_ctx.modelValue ? (openBlock(), createBlock("span", _hoisted_1$4, [createVNode("i", {
    class: _ctx.iconOn
  }, null, 2)])) : (openBlock(), createBlock("span", _hoisted_2$3, [createVNode("i", {
    class: _ctx.iconOff
  }, null, 2)])), _ctx.hasLabel ? (openBlock(), createBlock("span", _hoisted_3$2, toDisplayString(_ctx.modelValue ? _ctx.titleOn : _ctx.titleOff), 1)) : createCommentVNode("", true)], 10, ["title"]);
}

var css_248z$3 = "\r\n";
styleInject(css_248z$3);

script$4.render = render$4;

function useGridPaging(gridItems, pageSizes) {
  var pageableDefaults = {
    info: true,
    type: 'numeric',
    pageSizes: pageSizes,
    previousNext: true
  };
  var pageable = ref(_objectSpread2$1({}, pageableDefaults));
  var skip = ref(0);
  var take = ref(pageSizes[0]);
  var pageSize = pageSizes[0];
  var total = computed(function () {
    var _gridItems$value$leng, _gridItems$value;

    return (_gridItems$value$leng = gridItems === null || gridItems === void 0 ? void 0 : (_gridItems$value = gridItems.value) === null || _gridItems$value === void 0 ? void 0 : _gridItems$value.length) !== null && _gridItems$value$leng !== void 0 ? _gridItems$value$leng : 0;
  });
  var pageItems = computed(function () {
    return gridItems.value.slice(skip.value, take.value + skip.value);
  });

  var pageChangeHandler = function pageChangeHandler(event) {
    skip.value = event.page.skip;
    take.value = event.page.take;
  }; // Hide paging if all items fits on the smallest page size


  watch(total, function (newValue) {
    pageable.value = newValue <= pageSizes[0] ? null : _objectSpread2$1({}, pageableDefaults);
  }, {
    immediate: true
  });
  return {
    pageable: pageable,
    skip: skip,
    take: take,
    pageSize: pageSize,
    total: total,
    pageItems: pageItems,
    pageChangeHandler: pageChangeHandler
  };
}

function useGridFiltering(gridItems) {
  var filter = ref({
    logic: "and",
    filters: []
  });

  var filterChange = function filterChange(event) {
    filter.value = event.filter;
  };

  var filteredItems = computed(function () {
    return filterBy(gridItems.value, filter.value);
  });
  return {
    filterChange: filterChange,
    filteredItems: filteredItems,
    filter: filter
  };
}

function useGridSorting(gridItems) {
  var sort = ref([]);

  var sortChange = function sortChange(event) {
    sort.value = event.sort;
  };

  var sortedItems = computed(function () {
    return orderBy(gridItems.value, sort.value);
  });
  return {
    sortChange: sortChange,
    sortedItems: sortedItems,
    sort: sort
  };
}

/* Telerik bug - when scrollable set to none - there are missing some wrappers around thead 
- reported bug: https://feedback.telerik.com/kendo-vue-ui/1516159-the-styles-of-the-native-grid-change-when-the-scrollable-property-is-set-to-none
- when fixed we can set scrollable="none" to remove scrollbars
*/
var script$3 = defineComponent({
  name: "readOnlyGrid",
  components: {
    Grid: Grid,
    ToggleButton: script$4,
    GridNoRecords: GridNoRecords,
    loading: script$3$1
  },
  emits: ["rowClicked", "cellClicked"],
  props: {
    gridItems: {
      type: Array
    },
    gridColumns: {
      type: Array
    },
    showFilterToggle: {
      type: Boolean,
      default: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    pageItemsOptions: {
      type: Array,
      default: [5, 10, 30]
    },
    gridStyle: {
      type: Object
    },
    scrollable: {
      type: String,
      default: "none"
    }
  },
  setup: function setup(props) {
    var items = computed(function () {
      return props.gridItems || [];
    });
    var columns = props.gridColumns;

    var _useGridSorting = useGridSorting(items),
        sort = _useGridSorting.sort,
        sortChange = _useGridSorting.sortChange,
        sortedItems = _useGridSorting.sortedItems;

    var _useGridFiltering = useGridFiltering(sortedItems),
        filterChange = _useGridFiltering.filterChange,
        filteredItems = _useGridFiltering.filteredItems,
        filter = _useGridFiltering.filter;

    var isFilterOn = ref(false);

    var _useGridPaging = useGridPaging(filteredItems, props.pageItemsOptions),
        pageChangeHandler = _useGridPaging.pageChangeHandler,
        pageItems = _useGridPaging.pageItems,
        pageSize = _useGridPaging.pageSize,
        pageable = _useGridPaging.pageable,
        skip = _useGridPaging.skip,
        take = _useGridPaging.take,
        total = _useGridPaging.total;

    return {
      sort: sort,
      sortChange: sortChange,
      sortedItems: sortedItems,
      filterChange: filterChange,
      filteredItems: filteredItems,
      filter: filter,
      isFilterOn: isFilterOn,
      pageChangeHandler: pageChangeHandler,
      pageItems: pageItems,
      pageSize: pageSize,
      pageable: pageable,
      skip: skip,
      take: take,
      total: total,
      columns: columns
    };
  }
});

var _hoisted_1$3 = {
  class: "read-only-grid"
};
var _hoisted_2$2 = {
  key: 0
};
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ToggleButton = resolveComponent("ToggleButton");

  var _component_loading = resolveComponent("loading");

  var _component_GridNoRecords = resolveComponent("GridNoRecords");

  var _component_Grid = resolveComponent("Grid");

  return openBlock(), createBlock(Fragment, null, [_ctx.showFilterToggle ? (openBlock(), createBlock(_component_ToggleButton, {
    key: 0,
    modelValue: _ctx.isFilterOn,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.isFilterOn = $event;
    }),
    classAlways: "mb-3",
    iconOff: "k-icon k-i-filter",
    iconOn: "k-icon k-i-filter-clear",
    titleOn: "Hide filters",
    titleOff: "Show filters"
  }, null, 8, ["modelValue"])) : createCommentVNode("", true), createVNode("div", _hoisted_1$3, [createVNode(_component_Grid, {
    ref: "Grid",
    "data-items": _ctx.pageItems,
    columns: _ctx.columns,
    skip: _ctx.skip,
    take: _ctx.take,
    total: _ctx.total,
    pageable: _ctx.pageable,
    "page-size": _ctx.pageSize,
    sort: _ctx.sort,
    filter: _ctx.filter,
    sortable: true,
    resizable: true,
    filterable: _ctx.isFilterOn,
    style: _ctx.gridStyle,
    scrollable: _ctx.scrollable,
    onFilterchange: _ctx.filterChange,
    onPagechange: _ctx.pageChangeHandler,
    onSortchange: _ctx.sortChange,
    onRowclick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.$emit('rowClicked', $event);
    }),
    onCellclick: _cache[3] || (_cache[3] = function ($event) {
      return _ctx.$emit('cellClicked', $event);
    })
  }, {
    default: withCtx(function () {
      return [createVNode(_component_GridNoRecords, null, {
        default: withCtx(function () {
          return [!_ctx.isLoading ? (openBlock(), createBlock("span", _hoisted_2$2, "No records available")) : (openBlock(), createBlock(_component_loading, {
            key: 1
          }))];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data-items", "columns", "skip", "take", "total", "pageable", "page-size", "sort", "filter", "filterable", "style", "scrollable", "onFilterchange", "onPagechange", "onSortchange"])])], 64);
}

var css_248z$2 = "\n.k-dropdown-operator, .k-dropdown-operator .k-dropdown-wrap .k-select {\r\n  height: 100%;\n}\n.k-filtercell .k-filtercell-operator > .k-button.k-clear-button-visible {\r\n  height: 100%;\n}\na.cell-link {\r\n    display: block;\r\n    line-height: inherit;\r\n    height: 100%;\r\n    text-align: left;\r\n    padding-bottom: 0;\r\n    padding-top: 0;\r\n    padding-right: 0;\n}\r\n";
styleInject(css_248z$2);

script$3.render = render$3;

var script$2 = defineComponent({
  name: "searchBoxOptionsHeader",
  props: {
    currentValue: String
  }
});

var _hoisted_1$2 = {
  class: "has-text-weight-bold  m-0 p-2"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock("p", _hoisted_1$2, " Additional search options: ");
}

script$2.render = render$2;

/**
 * Enum for searchValue types.
 * @readonly
 * @enum {name: dropdownDescription}
 */
var SearchValueType = Object.freeze({
  Number: "number",
  String: "text",
  Date: "date: mm/dd/yyyy",
  Predefined: "select",
  NoSearchOption: ""
});
var SearchValueType$1 = SearchValueType;

var SearchCriterion = /*#__PURE__*/function () {
  function SearchCriterion(key) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SearchValueType$1.String;
    var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, SearchCriterion);

    this.key = key;
    this.searchValue = "";
    this.dropdownDescription = "";
    this.searchValueType = type;
    this.predefinedValues = values;
    this.dropdownDescription = this.searchValueType !== SearchValueType$1.NoSearchOption ? "".concat(this.key, ": (").concat(this.searchValueType, ")") : this.key;

    if (values !== null) {
      this.predefinedValues = this.toCriterionLikeArray(values);
    } else {
      this.predefinedValues = [];
    }
  }

  _createClass(SearchCriterion, [{
    key: "regex",
    get: function get() {
      switch (this.searchValueType) {
        case SearchValueType$1.Number:
          return new RegExp("^(".concat(this.key, "):\\W*(\\d*\\.?\\d*$)"));

        case SearchValueType$1.Date:
          return new RegExp("^(".concat(this.key, "):\\W*(\\d{2}/\\d{2}/\\d{4}$)"));

        case SearchValueType$1.String:
        default:
          return new RegExp("^(".concat(this.key, "):\\W*(\\w.*)"));
      }
    }
    /** Checks if the key and search value are valid. If no searchValue yet, then returns true. */

  }, {
    key: "isPreValid",
    get: function get() {
      var _this = this;

      // if there is no searchValue don't validate and return true
      if (!this.searchValue) {
        return true;
      }

      var validation = Boolean(this.searchValue) && this.regex.test("".concat(this.key, ":").concat(this.searchValue)); // if searchType is prePopulated do check if search value is one of the predefined ones

      if (this.searchValueType === SearchValueType$1.Predefined) {
        return validation && this.predefinedValues.some(function (a) {
          return a.key.toLowerCase() === _this.searchValue.toLowerCase();
        });
      }

      return validation;
    }
    /** Validates if the search key and value are valid and not blank. */

  }, {
    key: "isValid",
    get: function get() {
      var isValid = Boolean(this.searchValue) && this.isPreValid; // if it's string, then validate for the length (should be at least 3 chars)

      if (this.searchValueType === SearchValueType$1.String) {
        isValid = isValid && this.searchValue.length > 2;
      }

      return isValid;
    }
  }, {
    key: "errorMessage",
    get: function get() {
      var genericMessage = "\"".concat(this.key, "\" is invalid");

      switch (this.searchValueType) {
        case SearchValueType$1.Number:
          return "".concat(genericMessage, ". Number value is expected.");

        case SearchValueType$1.Date:
          return "".concat(genericMessage, ". Date value in format: mm/dd/yyyy is expected.");

        case SearchValueType$1.Predefined:
          return "".concat(genericMessage, ". Predefined search value from dropdown is expected.");

        case SearchValueType$1.String:
          return "".concat(genericMessage, ". Text search value of minimum 3 chars length is expected.");

        default:
          return "".concat(genericMessage, ". Please select one of the search option from the dropdown.");
      }
    }
    /** Returns the deepClone of the current searchCriterion */

  }, {
    key: "deepClone",
    value: function deepClone() {
      var clone = new SearchCriterion("");
      return Object.assign(clone, this);
    }
    /**
     * Converts the given array of string or enum to array of SearchCriterionLike objects.
     * @param values predefined values - either as array of string or enum
     * @returns returns the array of SearchCriterion object with 2 props: key and dropdownDescription
     */

  }, {
    key: "toCriterionLikeArray",
    value: function toCriterionLikeArray(values) {
      // if provided not array of string, but enum, first convert it to array of string
      if (!Array.isArray(values)) {
        values = Object.keys(values).filter(function (a) {
          return isNaN(Number(a));
        });
      }

      var result = [];
      values.forEach(function (a) {
        var val = {
          key: a,
          dropdownDescription: a
        };
        result.push(val);
      });
      return result;
    }
  }]);

  return SearchCriterion;
}();

var SearchBoxComposables = function SearchBoxComposables(props, emit) {
  /** All available search criteria. */
  var allCriteria = props.searchCriteria;

  if (!allCriteria.some(function (c) {
    return c.key === "any";
  })) {
    // add generic `any` option, if it's not already added.
    allCriteria.unshift(new SearchCriterion("any"));
  }
  /** Array for the filtered criteria shown in dropdown */


  var filteredCriteria = ref([]);
  filteredCriteria.value = _toConsumableArray(allCriteria); // get a shallow copy of allCriteria, so it can be modified later

  /** Array with parsedCriteria (searchOption - searchValue) */

  var parsedCriteria = ref([]);
  /** Array of search criteria that are not yet used by user. This list is used to filter searchOptions. */

  var notUsedCriteria = _toConsumableArray(allCriteria);

  var isSearchCriteriaSelected = ref(false);
  var isSearchOptionsOpened = ref(false);
  var isSearchValid = ref(true);
  var fullSearchValue = ref("");
  var noDataMessage = "NO SEARCH OPTION IS FOUND...";
  var noDataCriteria = new SearchCriterion(noDataMessage, SearchValueType$1.NoSearchOption);
  var errorTooltipContent = ref("");
  var errorTooltip = ref(null);
  var tooltipContent = "<p>How to search</p>\n    <ol>\n      <li >Provide search option:\n        <ul style=\"list-style:initial\">\n          <li>Either select one of the search options from dropdown</li>\n          <li>Or type search option followed by ':'</li>\n          <li>If no search option is provided, search is done using 'any' option (matches any search options).</li>\n          <li>Available wildcard chars:\n            <ul style=\"list-style:circle\">\n              <li><span style=\"font-size: 18px; font-weight: bold; display: inline\">*</span> &nbsp&nbsp&nbsp - represents zero or more chars: bl* finds bl, black, blue.</li>\n              <li><span style=\"font-size: 16px; font-weight: bold; display: inline\">?</span> &nbsp&nbsp&nbsp - represents a single char: h?t finds hot, hat, hit.</li>\n            </ul>\n          </li>\n        </ul>\n      </li>\n      <li>Provide search value.</li>\n      <li>Multiple search options can be combined.</li>\n      <li>Finds the results that matches ALL selected search terms.</li>\n      <li>Press 'Search' button. Check validation error (eg. 'abc' used where number is expected), if any.</li>\n    </ol>";
  /** On change of searchOptions props, update also filteredCriteria.
   * Change of searchOption after component initialization might needed in case of data fetch for pre-populated option values.
   * And we cannot take it directly from allCriteria, since we have only a shallow copy of it, in order not to modify original
   * allCriteria options.
   */

  watchEffect(function () {
    filteredCriteria.value = _toConsumableArray(allCriteria);
  });
  /** Filters provided criteria by filterValue. Returns array of filtered criteria. */

  var filterSearchOptions = function filterSearchOptions(filterValue, criteria) {
    // if there is some filter value, then apply filtering
    if (filterValue) {
      // searching only by lowerCase
      filterValue = filterValue.toLowerCase();

      var filtered = _toConsumableArray(criteria.filter(function (c) {
        return c.key.toLowerCase().includes(filterValue);
      }));

      if (filtered.length == 0) {
        filtered.push(noDataCriteria);
      }

      filteredCriteria.value = filtered;
    } // otherwise return all not yet used criteria
    else filteredCriteria.value = _toConsumableArray(criteria);
  };
  /** Clears the input value by parsing ':' and removing extra spaces. */


  var clearInputValue = function clearInputValue(inputValue) {
    // make sure that if there is `:` then it's followed by space
    var keys = inputValue.split(":");
    inputValue = "";
    keys.forEach(function (k) {
      return inputValue += "".concat(k.trimStart(), ": ");
    }); // don't include the last ': ' and removes multiple spaces if any

    return inputValue.substr(0, inputValue.length - 2).replace(/\s\s+/g, " ");
  };
  /** Parses the the given input value (whole search value together with options and values).
   * Adds the parsed option with value to parsedArray.
   * Returns the last token (last word from user input).
   */


  var parseInputValue = function parseInputValue(inputValue) {
    // clean all criteria in parsedCriteria array
    parsedCriteria.value.splice(0);
    inputValue = clearInputValue(inputValue);
    if (!inputValue) return ""; // parse the input by space - generate token
    // iterate over the each token and see if it's valid keySearch value

    var tokens = inputValue.split(" ");
    var currentCriterion = new SearchCriterion("any");
    var currentSearchValue = "";
    tokens.forEach(function (t, index) {
      // TODO: Handle the duplicate entered search options
      // // if we have already parsed this key (example 2x times the same search options is used)
      // const alreadyParsedKey = parsedCriteria.value.find(c => c.key + ":" === t);
      // if (alreadyParsedKey)
      //   currentCriterion = alreadyParsedKey as SearchCriterion;
      var key = allCriteria.find(function (c) {
        return c.key + ":" === t;
      }); // if key is matched, then update the currentCriterion searchValue and set currentCriterion with found key

      if (key) {
        // if it's first word from user input, then do the deepClone of the key
        if (index == 0) {
          currentCriterion = key.deepClone();
        } else {
          currentCriterion.searchValue = currentSearchValue.trim();
          parsedCriteria.value.push(currentCriterion);
          currentCriterion = key.deepClone();
          currentSearchValue = "";
        }
      } else {
        currentSearchValue += t + " ";
      }
    });
    currentCriterion.searchValue = currentSearchValue.trim();
    parsedCriteria.value.push(currentCriterion);
    notUsedCriteria = _toConsumableArray(allCriteria); // remove the parsed criteria from dropdown list

    parsedCriteria.value.forEach(function (k) {
      var index = notUsedCriteria.findIndex(function (c) {
        return c.key === k.key;
      });

      if (~index) {
        notUsedCriteria.splice(index, 1);
      }
    }); // return the last token - to use for suggestion

    return tokens[tokens.length - 1];
  };
  /** Returns key from user input (by extracting key from dropdown description). */


  var getKeyFromInput = function getKeyFromInput(inputValue) {
    // get the first word from selection
    return inputValue.split(" ")[0];
  };
  /** Returns true, if provided searchKey (string) is type of `noDataCriterion`. */


  var isNoDataCriterionSelected = function isNoDataCriterionSelected(key) {
    return key === noDataMessage;
  };
  /** Handles the change on each userInput. */


  var onSearchBoxValueChange = function onSearchBoxValueChange(message) {
    var _message$event, _message$event2;

    // if message is event - then user clicked somewhere else on the screen and no action is needed
    // if NoDataCriteria selected then do nothing (this is not a searchBoxValueChange event)
    if (isNoDataCriterionSelected(message.value) || message instanceof Event) {
      return;
    } // if this is event for change, then stopPropagation, so it's not triggering `Search` in case Enter is pressed
    // Enter can be pressed in case one of the value form dropdown is selected


    if (message.event) {
      message.event.stopPropagation();
    }

    var valueSelected = !message.event || ((_message$event = message.event) === null || _message$event === void 0 ? void 0 : _message$event.type) === "click" || ((_message$event2 = message.event) === null || _message$event2 === void 0 ? void 0 : _message$event2.code) === "Enter";
    var lastParsedSearchItem = parsedCriteria.value[parsedCriteria.value.length - 1]; // remove validation indicator in case of change

    isSearchValid.value = true;

    if (valueSelected && message.value) {
      var _lastParsedSearchItem;

      // if it's predefined values and new value is from predefinedValues, then just update the fullSearchValue with new value
      if (((_lastParsedSearchItem = lastParsedSearchItem) === null || _lastParsedSearchItem === void 0 ? void 0 : _lastParsedSearchItem.searchValueType) === SearchValueType$1.Predefined && lastParsedSearchItem.predefinedValues.some(function (a) {
        return a.key === message.value;
      })) {
        var lastSemicolonIndex = fullSearchValue.value.lastIndexOf(":");

        if (~lastSemicolonIndex) {
          fullSearchValue.value = fullSearchValue.value.substring(0, lastSemicolonIndex + 1);
        }

        fullSearchValue.value += message.value;
      } else {
        // remove the last element from fullSearchValue since it will be overwritten with selection from dropdown
        var lastSpaceIndex = fullSearchValue.value.lastIndexOf(" "); // intentionally not checking if lastSpaceIndex == -1, because if it's -1, it should remove
        // already existing values in fullSearchValue

        fullSearchValue.value = fullSearchValue.value.substring(0, lastSpaceIndex); // update the key

        fullSearchValue.value += " ".concat(getKeyFromInput(message.value)); // remove the starting space if any

        fullSearchValue.value = fullSearchValue.value.trimStart();
      }
    } else {
      fullSearchValue.value = message.value;
    } // parse the input


    var lastToken = parseInputValue(fullSearchValue.value); // update the last parsedItem after the parsing

    lastParsedSearchItem = parsedCriteria.value[parsedCriteria.value.length - 1]; // if the last parsedCriteria is preselectedType and doesn't have yet set searchValue, then update filterTypeValue

    if (lastParsedSearchItem && lastParsedSearchItem.searchValueType === SearchValueType$1.Predefined && (lastToken !== "" && !lastParsedSearchItem.isValid && !lastParsedSearchItem.searchValue.includes(" ") || lastToken === "" && lastParsedSearchItem.searchValue === "")) {
      filterSearchOptions(lastToken, lastParsedSearchItem.predefinedValues);
      setTimeout(function () {
        return isSearchOptionsOpened.value = true;
      });
    } else {
      // otherwise use search options and filter by search value
      filterSearchOptions(lastToken, notUsedCriteria);
    }
  };
  /** If searchOption is not yet selected make sure that dropdown (searchOptions) is kept open. */


  var onSearchBoxOpen = function onSearchBoxOpen() {
    if (!isSearchCriteriaSelected.value) {
      isSearchOptionsOpened.value = true;
    }
  };
  /** Keeps the dropdown (searchOptions) close on close event. */


  var onClose = function onClose() {
    isSearchOptionsOpened.value = false;
  };
  /** On focus of autocomplete automatically shows dropdown options, if searchOption is not yet selected. */


  var onFocus = function onFocus() {
    if (!isSearchCriteriaSelected.value) {
      isSearchOptionsOpened.value = true;
    }
  };
  /** Validates all parsedCriteria (array of criteria selected by user with search values).
   * If error, updates the errorTooltip content and marks search as `invalid`. 
   */


  var validateCriteria = function validateCriteria() {
    var errors = "<p class='error-tooltip'>Validation errors:</p><ol>";
    var isErrorFound = false; // handle case when no search option and value is provided.

    if (parsedCriteria.value.length === 0) {
      errors += "<li class=\"error-tooltip\">Nothing to search by. No search value provided.</li>";
      isErrorFound = true;
    }

    parsedCriteria.value.forEach(function (c) {
      if (!c.isValid) {
        errors += "<li class=\"error-tooltip\">".concat(c.errorMessage, "</li>");
        isErrorFound = true;
      }
    });

    if (isErrorFound) {
      errorTooltipContent.value = "".concat(errors, "</ol>");
      isSearchValid.value = false;
    } else {
      errorTooltipContent.value = "";
      isSearchValid.value = true;
    } // update the content of the tooltip


    setTimeout(function () {
      var _errorTooltip$value;

      return (_errorTooltip$value = errorTooltip.value) === null || _errorTooltip$value === void 0 ? void 0 : _errorTooltip$value.kendoWidget().refresh();
    });
  };
  /** Emits the parsedCriteria to parent component, in case of successful validation. */


  var onSearch = function onSearch() {
    validateCriteria();

    if (!isSearchValid.value) {
      return;
    } // translate searchCriteria into keyValue pair and handle the duplicate searchKey, if any


    var search = Object.create({});
    parsedCriteria.value.forEach(function (c) {
      // convert the key into camelCase (since js properties are camelCased and dash is not allowed in prop name)
      var key = _.camelCase(c.key);

      if (search[key]) {
        search[key] += " ".concat(c.searchValue);
      } else {
        search[key] = c.searchValue;
      }
    });
    emit("search", search);
  };

  return {
    filteredCriteria: filteredCriteria,
    parsedCriteria: parsedCriteria,
    isSearchOptionsOpened: isSearchOptionsOpened,
    isSearchValid: isSearchValid,
    fullSearchValue: fullSearchValue,
    noDataMessage: noDataMessage,
    errorTooltipContent: errorTooltipContent,
    errorTooltip: errorTooltip,
    tooltipContent: tooltipContent,
    onSearchBoxValueChange: onSearchBoxValueChange,
    onSearchBoxOpen: onSearchBoxOpen,
    onClose: onClose,
    onFocus: onFocus,
    onSearch: onSearch,
    parseInputValue: parseInputValue,
    allCriteria: allCriteria
  };
};

var SearchBoxComposables$1 = SearchBoxComposables;

var script$1 = defineComponent({
  name: "navbarSearchBox",
  components: {
    autoComplete: AutoComplete,
    tooltip: Tooltip,
    searchBoxOptionsHeader: script$2
  },
  props: {
    searchCriteria: {
      /** Array of searchCriterion items - they suits as dropdownOptions in searchBox. */
      type: Array,
      required: true
    }
  },
  emits: {
    search: Array
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var navigationSb = ref(null);
    var dropdown = ref(null);
    var showSearchContent = ref(false);

    var _SearchBoxComposables = SearchBoxComposables$1(props, emit),
        filteredCriteria = _SearchBoxComposables.filteredCriteria,
        parsedCriteria = _SearchBoxComposables.parsedCriteria,
        isSearchOptionsOpened = _SearchBoxComposables.isSearchOptionsOpened,
        isSearchValid = _SearchBoxComposables.isSearchValid,
        fullSearchValue = _SearchBoxComposables.fullSearchValue,
        errorTooltipContent = _SearchBoxComposables.errorTooltipContent,
        errorTooltip = _SearchBoxComposables.errorTooltip,
        tooltipContent = _SearchBoxComposables.tooltipContent,
        onSearchBoxValueChange = _SearchBoxComposables.onSearchBoxValueChange,
        onSearchBoxOpen = _SearchBoxComposables.onSearchBoxOpen,
        onClose = _SearchBoxComposables.onClose,
        onFocus = _SearchBoxComposables.onFocus,
        onSearch = _SearchBoxComposables.onSearch;

    var toggleSearchBox = function toggleSearchBox() {
      if (showSearchContent.value) {
        hideSearchBox();
      } else {
        showSearchContent.value = true; // set focus on the input

        nextTick(function () {
          return dropdown.value.input.focus();
        });
      }
    };

    var hideSearchBox = function hideSearchBox() {
      // hide searchContent, after searchOption dropdown is closed
      setTimeout(function () {
        return showSearchContent.value = false;
      }, 100);
    };

    var onNavbarSearch = function onNavbarSearch() {
      onSearch(); // close searchBox context of navigation if search is initiated.

      if (isSearchValid.value) {
        showSearchContent.value = false;
        fullSearchValue.value = "";
      }
    };

    onMounted(function () {
      navigationSb.value.clickOutsideEvent = function (event) {
        // if searchContent is already closed, then nothing to do.
        if (showSearchContent.value === false) {
          return;
        } // if it's click from  serachBox component, then do nothing


        if (navigationSb.value === event.target || navigationSb.value.contains(event.target)) {
          return;
        } // if it's a click form searchBox dropdown, then do nothing.


        var dropdown = document.getElementsByClassName("k-animation-container k-animation-container-relative")[0];

        if (dropdown && (dropdown === event.target || dropdown.contains(event.target))) {
          return;
        }

        hideSearchBox();
      };

      window.addEventListener("click", navigationSb.value.clickOutsideEvent);
    });
    onUnmounted(function () {
      if (navigationSb.value) {
        window.removeEventListener("click", navigationSb.value.clickOutsideEvent);
      }
    });
    return {
      navigationSb: navigationSb,
      dropdown: dropdown,
      filteredCriteria: filteredCriteria,
      parsedCriteria: parsedCriteria,
      onSearchBoxValueChange: onSearchBoxValueChange,
      onSearchBoxOpen: onSearchBoxOpen,
      onFocus: onFocus,
      onClose: onClose,
      onNavbarSearch: onNavbarSearch,
      isSearchOptionsOpened: isSearchOptionsOpened,
      tooltipContent: tooltipContent,
      errorTooltipContent: errorTooltipContent,
      isSearchValid: isSearchValid,
      fullSearchValue: fullSearchValue,
      showSearchContent: showSearchContent,
      errorTooltip: errorTooltip,
      hideSearchBox: hideSearchBox,
      toggleSearchBox: toggleSearchBox
    };
  }
});

var _withId = /*#__PURE__*/withScopeId("data-v-4f276449");

pushScopeId("data-v-4f276449");

var _hoisted_1$1 = {
  ref: "navigationSb"
};

var _hoisted_2$1 = /*#__PURE__*/createVNode("span", {
  class: "icon"
}, [/*#__PURE__*/createVNode("i", {
  class: "fas fa-search"
})], -1);

var _hoisted_3$1 = {
  key: 0,
  class: "search-box-container box"
};
var _hoisted_4$1 = {
  class: "search-expansion-content"
};
var _hoisted_5$1 = {
  class: "input-and-tooltip-content"
};
var _hoisted_6$1 = {
  class: "tooltip-content"
};

var _hoisted_7$1 = /*#__PURE__*/createVNode("span", {
  class: "k-icon k-i-question k-i-help help-icon"
}, null, -1);

var _hoisted_8$1 = {
  class: "k-icon k-i-warning error-icon"
};

var _hoisted_9$1 = /*#__PURE__*/createVNode("span", null, "Search", -1);

popScopeId();

var render$1 = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_search_box_options_header = resolveComponent("search-box-options-header");

  var _component_autoComplete = resolveComponent("autoComplete");

  var _component_tooltip = resolveComponent("tooltip");

  return openBlock(), createBlock("div", _hoisted_1$1, [createVNode("button", {
    type: "button",
    class: "button search-button-icon",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.toggleSearchBox && _ctx.toggleSearchBox.apply(_ctx, arguments);
    })
  }, [_hoisted_2$1]), createVNode(Transition, {
    name: "search-box-expand"
  }, {
    default: _withId(function () {
      return [_ctx.showSearchContent ? (openBlock(), createBlock("div", _hoisted_3$1, [createVNode("div", _hoisted_4$1, [createVNode("div", _hoisted_5$1, [createVNode(_component_autoComplete, {
        ref: "dropdown",
        "data-items": _ctx.filteredCriteria,
        placeholder: 'Please select an option and provide search value...',
        "text-field": 'dropdownDescription',
        opened: _ctx.isSearchOptionsOpened,
        header: 'searchOptionsHeader',
        value: _ctx.fullSearchValue,
        class: "mr-2 search-box-input",
        onChange: _ctx.onSearchBoxValueChange,
        onOpen: _ctx.onSearchBoxOpen,
        onFocus: _ctx.onFocus,
        onClose: _ctx.onClose,
        onKeydown: withKeys(_ctx.onNavbarSearch, ["enter"])
      }, {
        searchOptionsHeader: _withId(function () {
          return [createVNode(_component_search_box_options_header)];
        }),
        _: 1
      }, 8, ["data-items", "placeholder", "opened", "value", "onChange", "onOpen", "onFocus", "onClose", "onKeydown"]), createVNode("div", _hoisted_6$1, [createVNode(_component_tooltip, {
        class: "is-inline",
        content: _ctx.tooltipContent,
        position: 'bottom',
        filter: 'span'
      }, {
        default: _withId(function () {
          return [_hoisted_7$1];
        }),
        _: 1
      }, 8, ["content"]), createVNode(_component_tooltip, {
        class: "is-inline navbar-error-tooltip",
        content: _ctx.errorTooltipContent,
        position: 'bottom',
        filter: 'span',
        ref: "errorTooltip"
      }, {
        default: _withId(function () {
          return [withDirectives(createVNode("span", _hoisted_8$1, null, 512), [[vShow, !_ctx.isSearchValid]])];
        }),
        _: 1
      }, 8, ["content"])])]), createVNode("button", {
        type: "button",
        class: "button is-warning is-small",
        style: {
          "border": "none"
        },
        onClick: _cache[2] || (_cache[2] = function () {
          return _ctx.onNavbarSearch && _ctx.onNavbarSearch.apply(_ctx, arguments);
        })
      }, [_hoisted_9$1])])])) : createCommentVNode("", true)];
    }),
    _: 1
  })], 512);
});

var css_248z$1 = "\n.search-box-container[data-v-4f276449] {\r\n  position: absolute;\r\n  top: calc(100% + -5px);\r\n  right: -110px;\r\n  padding: 15px;\r\n  border-radius: 5px;\n}\n.help-icon[data-v-4f276449],\r\n.error-icon[data-v-4f276449] {\r\n  font-size: 20px;\n}\n.search-box-input[data-v-4f276449] input,\r\n.search-box-input[data-v-4f276449] input:focus {\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n  font-size: 12px !important;\n}\n.search-box-expand-enter-from[data-v-4f276449],\r\n.search-box-expand-leave-to[data-v-4f276449] {\r\n  opacity: 0;\n}\n.search-box-expand-enter-active[data-v-4f276449],\r\n.search-box-expand-leave-active[data-v-4f276449] {\r\n  transition: all 0.35s ease-in-out;\n}\n.search-expansion-content[data-v-4f276449] {\r\n  display: flex;\r\n  justify-content: flex-end;\n}\n.input-and-tooltip-content[data-v-4f276449] {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\n}\n.tooltip-content[data-v-4f276449] {\r\n  width: 60px;\n}\n.search-button-icon[data-v-4f276449] {\r\n  border: none;\r\n  background-color: inherit;\r\n  transition: all 1s;\n}\n.search-button-icon[data-v-4f276449]:focus {\r\n  box-shadow: none !important;\n}\n.search-button-icon[data-v-4f276449]:hover {\r\n  background-color: #efefef;\r\n  transition: all 2s;\n}\r\n";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-4f276449";

var script = defineComponent({
  name: "pageSearchBox",
  components: {
    autoComplete: AutoComplete,
    tooltip: Tooltip,
    searchBoxOptionsHeader: script$2,
    loading: script$3$1
  },
  props: {
    searchCriteria: {
      /** Array of searchCriterion items - they suits as dropdownOptions in searchBox. */
      type: Array,
      required: true
    },
    providedSearchValue: {
      /** SearchValue initially provided in navBarSearchBox. Used in case searchPage is navigated from navBarSearchBox component. */
      type: String,
      default: ""
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    search: Array
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _SearchBoxComposables = SearchBoxComposables$1(props, emit),
        filteredCriteria = _SearchBoxComposables.filteredCriteria,
        parsedCriteria = _SearchBoxComposables.parsedCriteria,
        isSearchOptionsOpened = _SearchBoxComposables.isSearchOptionsOpened,
        isSearchValid = _SearchBoxComposables.isSearchValid,
        fullSearchValue = _SearchBoxComposables.fullSearchValue,
        errorTooltipContent = _SearchBoxComposables.errorTooltipContent,
        errorTooltip = _SearchBoxComposables.errorTooltip,
        tooltipContent = _SearchBoxComposables.tooltipContent,
        onSearchBoxValueChange = _SearchBoxComposables.onSearchBoxValueChange,
        onSearchBoxOpen = _SearchBoxComposables.onSearchBoxOpen,
        onClose = _SearchBoxComposables.onClose,
        onFocus = _SearchBoxComposables.onFocus,
        onSearch = _SearchBoxComposables.onSearch,
        parseInputValue = _SearchBoxComposables.parseInputValue,
        allCriteria = _SearchBoxComposables.allCriteria; // if any searchValue is provided intiially, then apply


    if (props.providedSearchValue) {
      fullSearchValue.value = props.providedSearchValue;
      parseInputValue(fullSearchValue.value);
    }
    /** Triggers on chipClose and removes the value from input value and parsedCriteria array. */


    var onChipClose = function onChipClose(criterion) {
      var indexToRemove = parsedCriteria.value.indexOf(criterion);

      if (~indexToRemove) {
        parsedCriteria.value.splice(indexToRemove, 1);
      } // handle the special Regex char (*, ?, ... ) by parsing all not word, digit or whitespace char


      var searchValueRegex = "";
      var matchedSpecChars = criterion.searchValue.match(/[\w\s\d]*/g);

      if (matchedSpecChars.every(function (c) {
        return c === "" || c === " ";
      })) {
        searchValueRegex = "\\W*(\\s|$)";
      } else {
        matchedSpecChars.forEach(function (r) {
          // replace all specRegex char with `.*` - any placeholder with arbitrary length
          if (!(r === "" || r === " ")) {
            // concatenate all found values followed by matching any string with arbitrary length
            searchValueRegex += r + ".*";
          }
        });
        searchValueRegex = searchValueRegex.substr(0, searchValueRegex.length - 2) + "\\S*(\\s|$)";
      } // if it's first parsed searchCriterion and has type any, it might not have `any` specified explicitly in search field


      var regex = criterion.key === "any" && indexToRemove === 0 ? new RegExp("(?:".concat(criterion.key, ":)?\\s*[^\\w\\s\\d]*(").concat(searchValueRegex, ")")) : new RegExp("".concat(criterion.key, ":\\s*[^\\w\\s\\d]*(").concat(searchValueRegex, ")"));
      fullSearchValue.value = fullSearchValue.value.replace(regex, "").trim(); // if the searchingValue is empty, make sure that filteredCriteria is filled with all criteria options.

      if (!fullSearchValue.value) {
        filteredCriteria.value = _toConsumableArray(allCriteria);
      }
    };

    var onSearchWithLoading = function onSearchWithLoading($event) {
      if (props.isLoading) return;
      onSearch($event);
    };

    return {
      filteredCriteria: filteredCriteria,
      parsedCriteria: parsedCriteria,
      onChipClose: onChipClose,
      onSearchBoxValueChange: onSearchBoxValueChange,
      onSearchBoxOpen: onSearchBoxOpen,
      onFocus: onFocus,
      onClose: onClose,
      onSearchWithLoading: onSearchWithLoading,
      isSearchOptionsOpened: isSearchOptionsOpened,
      tooltipContent: tooltipContent,
      errorTooltipContent: errorTooltipContent,
      isSearchValid: isSearchValid,
      fullSearchValue: fullSearchValue,
      errorTooltip: errorTooltip
    };
  }
});

var _hoisted_1 = {
  class: "search-box-container"
};
var _hoisted_2 = {
  class: "selected-criteria-container"
};

var _hoisted_3 = /*#__PURE__*/createVNode("p", {
  class: "selected-wrapper"
}, "Searching by:", -1);

var _hoisted_4 = {
  class: "search-chip-content"
};
var _hoisted_5 = {
  style: {
    "margin-right": "6px"
  }
};
var _hoisted_6 = {
  key: 0,
  class: "k-icon k-i-warning error-chip-icon"
};
var _hoisted_7 = {
  key: 1,
  class: "k-icon k-i-warning error-chip-icon"
};
var _hoisted_8 = {
  class: "search-expansion-content"
};
var _hoisted_9 = {
  class: "input-and-tooltip-content"
};
var _hoisted_10 = {
  class: "loading-wrapper"
};
var _hoisted_11 = {
  class: "tooltip-content"
};

var _hoisted_12 = /*#__PURE__*/createVNode("span", {
  class: "k-icon k-i-question k-i-help help-icon"
}, null, -1);

var _hoisted_13 = {
  class: "k-icon k-i-warning error-icon"
};

var _hoisted_14 = /*#__PURE__*/createVNode("span", {
  class: "icon"
}, [/*#__PURE__*/createVNode("i", {
  class: "fas fa-search"
})], -1);

var _hoisted_15 = /*#__PURE__*/createVNode("span", null, "Search", -1);

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_search_box_options_header = resolveComponent("search-box-options-header");

  var _component_autoComplete = resolveComponent("autoComplete");

  var _component_loading = resolveComponent("loading");

  var _component_tooltip = resolveComponent("tooltip");

  return openBlock(), createBlock("div", null, [createVNode("div", _hoisted_1, [createVNode("div", _hoisted_2, [_hoisted_3, (openBlock(true), createBlock(Fragment, null, renderList(_ctx.parsedCriteria, function (criterion) {
    return openBlock(), createBlock("span", {
      class: "search-chip",
      key: criterion.key
    }, [createVNode("span", _hoisted_4, [createVNode("span", _hoisted_5, toDisplayString(criterion === null || criterion === void 0 ? void 0 : criterion.key) + ": " + toDisplayString(criterion === null || criterion === void 0 ? void 0 : criterion.searchValue), 1), createVNode(Transition, {
      name: "prevalid-fade",
      mode: "out-in"
    }, {
      default: withCtx(function () {
        return [!(criterion !== null && criterion !== void 0 && criterion.isPreValid) && _ctx.isSearchValid ? (openBlock(), createBlock("span", _hoisted_6)) : !(criterion !== null && criterion !== void 0 && criterion.isValid) && !_ctx.isSearchValid ? (openBlock(), createBlock("span", _hoisted_7)) : createCommentVNode("", true)];
      }),
      _: 2
    }, 1024), createVNode("button", {
      type: "button",
      "aria-label": "Close",
      class: "k-icon k-i-close search-chip-close-button",
      onClick: function onClick($event) {
        return _ctx.onChipClose(criterion);
      }
    }, null, 8, ["onClick"])])]);
  }), 128))]), createVNode("div", _hoisted_8, [createVNode("div", _hoisted_9, [createVNode(_component_autoComplete, {
    ref: "myAutoComplete",
    "data-items": _ctx.filteredCriteria,
    placeholder: 'Please select an option and provide search value...',
    "text-field": 'dropdownDescription',
    opened: _ctx.isSearchOptionsOpened,
    header: 'searchOptionsHeader',
    value: _ctx.fullSearchValue,
    class: "mr-2 search-box-input",
    onChange: _ctx.onSearchBoxValueChange,
    onOpen: _ctx.onSearchBoxOpen,
    onFocus: _ctx.onFocus,
    onClose: _ctx.onClose,
    onKeydown: withKeys(_ctx.onSearchWithLoading, ["enter"])
  }, {
    searchOptionsHeader: withCtx(function () {
      return [createVNode(_component_search_box_options_header)];
    }),
    _: 1
  }, 8, ["data-items", "placeholder", "opened", "value", "onChange", "onOpen", "onFocus", "onClose", "onKeydown"]), createVNode("div", _hoisted_10, [_ctx.isLoading ? (openBlock(), createBlock(_component_loading, {
    key: 0
  })) : createCommentVNode("", true)]), createVNode("div", _hoisted_11, [createVNode(_component_tooltip, {
    class: "is-inline",
    content: _ctx.tooltipContent,
    position: 'bottom',
    filter: 'span'
  }, {
    default: withCtx(function () {
      return [_hoisted_12];
    }),
    _: 1
  }, 8, ["content"]), createVNode(_component_tooltip, {
    class: "is-inline",
    content: _ctx.errorTooltipContent,
    position: 'bottom',
    filter: 'span',
    ref: "errorTooltip"
  }, {
    default: withCtx(function () {
      return [withDirectives(createVNode("span", _hoisted_13, null, 512), [[vShow, !_ctx.isSearchValid]])];
    }),
    _: 1
  }, 8, ["content"])])]), createVNode("button", {
    disabled: _ctx.isLoading,
    type: "button",
    class: "button search-button is-warning",
    style: {
      "border": "none"
    },
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.onSearchWithLoading && _ctx.onSearchWithLoading.apply(_ctx, arguments);
    })
  }, [_hoisted_14, _hoisted_15], 8, ["disabled"])])])]);
}

var css_248z = "\n.search-box-container {\r\n  position: relative;\r\n  overflow: hidden;\r\n  border: 1px solid #f0e8e8;\r\n  border-radius: 10px;\r\n  padding: 15px 10px;\n}\n.selected-wrapper {\r\n  display: inline;\r\n  padding: 5px 10px;\r\n  font-size: 14px;\r\n  color: grey;\n}\n.selected-criteria-container {\r\n  margin-bottom: 5px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\n}\n.search-chip {\r\n  border-radius: 16px;\r\n  font-size: 12px;\r\n  height: 27px;\r\n  background-color: #f6f6f6 !important;\r\n  align-items: center;\r\n  cursor: default;\r\n  padding: 0 10px;\r\n  margin-right: 5px;\r\n  border: 1px #e7dfdf solid !important;\n}\n.search-chip-content {\r\n  align-items: center;\r\n  display: inline-flex;\r\n  height: 100%;\r\n  max-width: 100%;\r\n  color: #797c7f;\n}\n.search-chip-close-button {\r\n  font-size: 10px;\r\n  height: 16px;\r\n  width: 12px;\r\n  align-self: center;\r\n  color: darkgray;\r\n  top: 1px;\r\n  border-radius: 10px;\n}\n.help-icon,\r\n.error-icon {\r\n  font-size: 26px;\n}\n.error-chip-icon {\r\n  font-size: 16px;\r\n  display: inline-flex;\r\n  margin-right: 2px;\n}\n.invalid-chip,\r\n.invalid-chip span.search-chip-content {\r\n  background-color: #c8102e !important;\r\n  color: white !important;\n}\n.error-icon,\r\n.error-chip-icon,\r\n.error-tooltip {\r\n  color: #c8102e;\n}\n.search-box-input {\r\n  flex-grow: 2 !important;\r\n  min-width: 300px !important;\n}\n.search-box-input input,\r\n.search-box-input input:focus {\r\n  border: none !important;\r\n  box-shadow: none !important;\n}\n.k-tooltip-content {\r\n  vertical-align: middle;\n}\n.k-tooltip {\r\n  background-color: #ffffff !important;\r\n  border-radius: 10px;\r\n  padding: 20px;\r\n  border: 1px #e4e4e4 solid;\r\n  color: #4a4a4a;\n}\n.k-tooltip-content p {\r\n  font-size: 1.2em;\r\n  padding-bottom: 10px;\n}\n.k-tooltip-content li {\r\n  font-size: 1em;\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n  padding-bottom: 5px;\r\n  margin-left: 25px;\n}\n.k-tooltip-content span {\r\n  margin-bottom: 10px;\r\n  display: block;\n}\n.k-tooltip-content hr {\r\n  margin: 15px 0;\n}\n.k-tooltip-content hr {\r\n  background-color: #d1d0d0;\r\n  height: 1px;\n}\n.error-tooltip {\r\n  color: #c8102e;\n}\n.prevalid-fade-enter-active {\r\n  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);\n}\n.prevalid-fade-leave-active {\r\n  transition: all 0.4s ease;\n}\n.prevalid-fade-enter-from,\r\n.prevalid-fade-leave-to {\r\n  opacity: 0;\n}\n.search-expansion-content {\r\n  display: flex;\r\n  justify-content: flex-end;\n}\n.input-and-tooltip-content {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\n}\n.tooltip-content {\r\n  width: 85px;\n}\n.loading-wrapper {\r\n  width: 100%;\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\n}\n.loading-wrapper .loading {\r\n  bottom: 0;\r\n  height: 8px;\n}\r\n";
styleInject(css_248z);

script.render = render;

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  formComponents: index$1,
  layoutComponents: index,
  reviewManager: script$5,
  decisionDialog: script$6,
  toggleButton: script$4,
  readOnlyGrid: script$3,
  autoComplete: script$r,
  fileUpload: script$m,
  formAutoComplete: script$k,
  formField: script$l,
  formInput: script$j,
  formSelect: script$h,
  formText: script$g,
  selectCurrency: script$f,
  selectOption: script$i,
  qtyInput: script$e,
  dirtyTracker: script$c,
  discardChangesDialog: script$d,
  accountMenu: script$b,
  navbar: script$7,
  navbarItems: script$a,
  NavbarMenuItem: NavbarMenuItem,
  ebizAppsItem: script$9,
  navbarSearchBox: script$1,
  pageSearchBox: script,
  SearchValueType: SearchValueType$1,
  SearchCriterion: SearchCriterion
});

function renderCellWithLink(createLink) {
  return function (render, tdElement, props) {
    var link = createLink(props.dataItem);
    var el = link ? "a" : "span";
    var elProps = link ? {
      href: link,
      class: "button is-ghost cell-link"
    } : {};
    var content = utils.getNestedValue(props.field, props.dataItem);
    return render(tdElement, render(el, elProps, content));
  };
}

function renderCellWithRoute(createRoute) {
  return function (render, tdElement, props) {
    return render(tdElement, render(RouterLink, {
      to: createRoute(props.dataItem),
      class: "button is-ghost cell-link"
    }, {
      // RouterLink value returned as a default slot function to avoid Vue performance issues warning
      default: function _default() {
        return utils.getNestedValue(props.field, props.dataItem);
      }
    }));
  };
}

function renderCellWithCustomComponent(component) {
  return function (render, vNode, props) {
    return render(component, props);
  };
}

function renderFilterableCellWithDatetime(dateTimePropName, format) {
  return function (render, tdElement, props) {
    return render(tdElement, {}, utils.getFormatedDate(dateTimePropName, props.dataItem, format));
  };
}

function renderIconCell(createIconFn) {
  return function (render, tdElement, dataItem) {
    return render(tdElement, {}, render("i", {
      class: createIconFn(dataItem)
    }));
  };
}

var install = function installVuePhoenix(app) {
  Object.entries(components).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        componentName = _ref2[0],
        component = _ref2[1];

    app.component(componentName, component);
  });
}; // Create module definition for Vue.use()

export { JsonClient$1 as JsonClient, NavbarMenuItem, SearchCriterion, SearchValueType$1 as SearchValueType, script$b as accountMenu, index$5 as auth, script$r as autoComplete, clickOutside, script$6 as decisionDialog, install as default, script$c as dirtyTracker, script$d as discardChangesDialog, ebizApps, script$9 as ebizAppsItem, index$4 as errorHandling, script$m as fileUpload, script$k as formAutoComplete, index$1 as formComponents, script$l as formField, script$j as formInput, script$h as formSelect, script$g as formText, index$3 as formValidation, index as layoutComponents, script$7 as navbar, script$a as navbarItems, script$1 as navbarSearchBox, index$2 as notifications, script as pageSearchBox, script$e as qtyInput, script$3 as readOnlyGrid, renderCellWithCustomComponent, renderCellWithLink, renderCellWithRoute, renderFilterableCellWithDatetime, renderIconCell, script$5 as reviewManager, script$f as selectCurrency, script$i as selectOption, script$4 as toggleButton, utils };
